/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Tab, TabContainer } from "@lightspeed/flame/Tab";
import { Card } from "@lightspeed/flame/Card";
import { Input } from "@lightspeed/flame/Input";
import { Button } from "@lightspeed/flame/Button";
import { FaCog, FaCompressAlt, FaExpandAlt, FaInfoCircle, FaPlus, FaSearch, FaTrash } from "react-icons/fa";
import * as databaseActions from "../../redux/actions/databaseActions";
import { getShopImportPO, setShopImportPO } from "../../redux/actions/importPOActions";
import {
  setCurrentTable,
  setSearch,
  setSettings as setUiSettings,
  setShowHiddenFields,
} from "../../redux/actions/uiActions";
import { Modal } from "@lightspeed/flame/Modal";
import roundingS2Image from "../../assets/Rounding_S2.png";
import receiptImage from "../../assets/Receipt.png";
import surchargeExampleImage from "../../assets/SurchargeExample.png";
import kSeriesOrderTagImage from "../../assets/k_series_order_tag.jpg";
import kSeriesStatisticGroupImage from "../../assets/k_series_statistig_grouop_id.jpg";
import kSeriesStatisticItemImage from "../../assets/k_series_statistig_item_id.jpg";
import { useI18n } from "../../utils/i18n";
import { isAcombaIntegration, isAcombaSdkIntegration } from "../../utils/d365Dimensions";
import { serverUrl } from "../../serverUrl";

const Tip = ({ title, style, onClick }) => (
  <span
    title={title}
    aria-label="Help"
    role={onClick ? "button" : "img"}
    tabIndex={onClick ? 0 : undefined}
    onClick={onClick}
    onKeyDown={
      onClick
        ? (event) => {
            if (event.key === "Enter" || event.key === " ") {
              onClick(event);
            }
          }
        : undefined
    }
    style={{
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      width: 18,
      height: 18,
      borderRadius: "50%",
      border: "1px solid currentColor",
      fontSize: 12,
      fontWeight: 700,
      lineHeight: "18px",
      cursor: onClick ? "pointer" : "help",
      userSelect: "none",
      opacity: 0.85,
      ...style,
    }}
  >
    ?
  </span>
);

const CategorieBar = () => {
  const [emailList, setEmailList] = useState("");
  const [timeSelection, setTimeSelection] = useState("0");
  const [showSettings, setShowSettings] = useState(false);
  const [showAmortizedSettings, setShowAmortizedSettings] = useState(false);
  const [amortizedSettingsLoading, setAmortizedSettingsLoading] = useState(false);
  const [amortizedSnapshot, setAmortizedSnapshot] = useState(null);
  const [amortizedItemsByCategory, setAmortizedItemsByCategory] = useState({});
  const [amortizedItemsLoading, setAmortizedItemsLoading] = useState({});
  const [amortizedItemsError, setAmortizedItemsError] = useState({});
  const [tabInfo, setTabInfo] = useState(null);
  const [enlargedImage, setEnlargedImage] = useState(null);
  const [showTableSearch, setShowTableSearch] = useState(false);
  const [settingsTab, setSettingsTab] = useState("general");

  const dispatch = useDispatch();
  const { t } = useI18n();
  const ui = useSelector((state) => state.ui);
  const database = useSelector((state) => state.database);
  const userState = useSelector((state) => state.userState);
  const acombagoIntegration = isAcombaIntegration(database.currentCompany, database.currentShop);
  const showImportsPO = database.currentCompany.type === "RETAIL" &&
    isAcombaSdkIntegration(database.currentCompany, database.currentShop);

  const [isSaving, setIsSaving] = useState(false);
  const [saveError, setSaveError] = useState(null);
  const [saveSuccess, setSaveSuccess] = useState(false);

  const SETTINGS_URL =
    database.currentCompany.type === "RESTO"
      ? "https://reportapi.beesql.com/api/admin/restol/report"
      : "https://reportapi.beesql.com/api/admin/retailr/report";

  const TIMEZONES = [
    { name: "Afghanistan Standard Time", offset: "+04:30" },
    { name: "Alaskan Standard Time", offset: "-08:00" },
    { name: "Aleutian Standard Time", offset: "-09:00" },
    { name: "Altai Standard Time", offset: "+07:00" },
    { name: "Arab Standard Time", offset: "+03:00" },
    { name: "Arabian Standard Time", offset: "+04:00" },
    { name: "Arabic Standard Time", offset: "+03:00" },
    { name: "Argentina Standard Time", offset: "-03:00" },
    { name: "Astrakhan Standard Time", offset: "+04:00" },
    { name: "Atlantic Standard Time", offset: "-03:00" },
    { name: "AUS Central Standard Time", offset: "+09:30" },
    { name: "Aus Central W. Standard Time", offset: "+08:45" },
    { name: "AUS Eastern Standard Time", offset: "+10:00" },
    { name: "Azerbaijan Standard Time", offset: "+04:00" },
    { name: "Azores Standard Time", offset: "+00:00" },
    { name: "Bahia Standard Time", offset: "-03:00" },
    { name: "Bangladesh Standard Time", offset: "+06:00" },
    { name: "Bougainville Standard Time", offset: "+11:00" },
    { name: "Canada Central Standard Time", offset: "-06:00" },
    { name: "Cape Verde Standard Time", offset: "-01:00" },
    { name: "Caucasus Standard Time", offset: "+04:00" },
    { name: "Cen. Australia Standard Time", offset: "+09:30" },
    { name: "Central America Standard Time", offset: "-06:00" },
    { name: "Central Asia Standard Time", offset: "+06:00" },
    { name: "Central Brazilian Standard Time", offset: "-04:00" },
    { name: "Central Europe Standard Time", offset: "+02:00" },
    { name: "Central European Standard Time", offset: "+02:00" },
    { name: "Central Pacific Standard Time", offset: "+11:00" },
    { name: "Central Standard Time", offset: "-05:00" },
    { name: "Central Standard Time (Mexico)", offset: "-06:00" },
    { name: "Chatham Islands Standard Time", offset: "+12:45" },
    { name: "China Standard Time", offset: "+08:00" },
    { name: "Cuba Standard Time", offset: "-04:00" },
    { name: "Dateline Standard Time", offset: "-12:00" },
    { name: "E. Africa Standard Time", offset: "+03:00" },
    { name: "E. Australia Standard Time", offset: "+10:00" },
    { name: "E. Europe Standard Time", offset: "+03:00" },
    { name: "E. South America Standard Time", offset: "-03:00" },
    { name: "Easter Island Standard Time", offset: "-06:00" },
    { name: "Eastern Standard Time", offset: "-04:00" },
    { name: "Eastern Standard Time (Mexico)", offset: "-05:00" },
    { name: "Egypt Standard Time", offset: "+03:00" },
    { name: "Ekaterinburg Standard Time", offset: "+05:00" },
    { name: "Fiji Standard Time", offset: "+12:00" },
    { name: "FLE Standard Time", offset: "+03:00" },
    { name: "Georgian Standard Time", offset: "+04:00" },
    { name: "GMT Standard Time", offset: "+01:00" },
    { name: "Greenland Standard Time", offset: "-01:00" },
    { name: "Greenwich Standard Time", offset: "+00:00" },
    { name: "GTB Standard Time", offset: "+03:00" },
    { name: "Haiti Standard Time", offset: "-04:00" },
    { name: "Hawaiian Standard Time", offset: "-10:00" },
    { name: "India Standard Time", offset: "+05:30" },
    { name: "Iran Standard Time", offset: "+03:30" },
    { name: "Israel Standard Time", offset: "+03:00" },
    { name: "Jordan Standard Time", offset: "+03:00" },
    { name: "Kaliningrad Standard Time", offset: "+02:00" },
    { name: "Kamchatka Standard Time", offset: "+13:00" },
    { name: "Korea Standard Time", offset: "+09:00" },
    { name: "Libya Standard Time", offset: "+02:00" },
    { name: "Line Islands Standard Time", offset: "+14:00" },
    { name: "Lord Howe Standard Time", offset: "+10:30" },
    { name: "Magadan Standard Time", offset: "+11:00" },
    { name: "Magallanes Standard Time", offset: "-03:00" },
    { name: "Marquesas Standard Time", offset: "-09:30" },
    { name: "Mauritius Standard Time", offset: "+04:00" },
    { name: "Mid-Atlantic Standard Time", offset: "-01:00" },
    { name: "Middle East Standard Time", offset: "+03:00" },
    { name: "Montevideo Standard Time", offset: "-03:00" },
    { name: "Morocco Standard Time", offset: "+01:00" },
    { name: "Mountain Standard Time", offset: "-06:00" },
    { name: "Mountain Standard Time (Mexico)", offset: "-07:00" },
    { name: "Myanmar Standard Time", offset: "+06:30" },
    { name: "N. Central Asia Standard Time", offset: "+07:00" },
    { name: "Namibia Standard Time", offset: "+02:00" },
    { name: "Nepal Standard Time", offset: "+05:45" },
    { name: "New Zealand Standard Time", offset: "+12:00" },
    { name: "Newfoundland Standard Time", offset: "-02:30" },
    { name: "Norfolk Standard Time", offset: "+11:00" },
    { name: "North Asia East Standard Time", offset: "+08:00" },
    { name: "North Asia Standard Time", offset: "+07:00" },
    { name: "North Korea Standard Time", offset: "+09:00" },
    { name: "Omsk Standard Time", offset: "+06:00" },
    { name: "Pacific SA Standard Time", offset: "-04:00" },
    { name: "Pacific Standard Time", offset: "-07:00" },
    { name: "Pacific Standard Time (Mexico)", offset: "-07:00" },
    { name: "Pakistan Standard Time", offset: "+05:00" },
    { name: "Paraguay Standard Time", offset: "-03:00" },
    { name: "Qyzylorda Standard Time", offset: "+05:00" },
    { name: "Romance Standard Time", offset: "+02:00" },
    { name: "SA Eastern Standard Time", offset: "-03:00" },
    { name: "SA Pacific Standard Time", offset: "-05:00" },
    { name: "SA Western Standard Time", offset: "-04:00" },
    { name: "Saint Pierre Standard Time", offset: "-02:00" },
    { name: "Sakhalin Standard Time", offset: "+11:00" },
    { name: "Samoa Standard Time", offset: "+13:00" },
    { name: "Sao Tome Standard Time", offset: "+00:00" },
    { name: "Saratov Standard Time", offset: "+04:00" },
    { name: "SE Asia Standard Time", offset: "+07:00" },
    { name: "Singapore Standard Time", offset: "+08:00" },
    { name: "South Africa Standard Time", offset: "+02:00" },
    { name: "South Sudan Standard Time", offset: "+02:00" },
    { name: "Sri Lanka Standard Time", offset: "+05:30" },
    { name: "Sudan Standard Time", offset: "+02:00" },
    { name: "Syria Standard Time", offset: "+03:00" },
    { name: "Taipei Standard Time", offset: "+08:00" },
    { name: "Tasmania Standard Time", offset: "+10:00" },
    { name: "Tocantins Standard Time", offset: "-03:00" },
    { name: "Tokyo Standard Time", offset: "+09:00" },
    { name: "Tomsk Standard Time", offset: "+07:00" },
    { name: "Tonga Standard Time", offset: "+13:00" },
    { name: "Transbaikal Standard Time", offset: "+09:00" },
    { name: "Turkey Standard Time", offset: "+03:00" },
    { name: "Turks And Caicos Standard Time", offset: "-04:00" },
    { name: "Ulaanbaatar Standard Time", offset: "+08:00" },
    { name: "US Eastern Standard Time", offset: "-04:00" },
    { name: "US Mountain Standard Time", offset: "-07:00" },
    { name: "UTC", offset: "+00:00" },
    { name: "UTC+12", offset: "+12:00" },
    { name: "UTC+13", offset: "+13:00" },
    { name: "UTC-02", offset: "-02:00" },
    { name: "UTC-08", offset: "-08:00" },
    { name: "UTC-09", offset: "-09:00" },
    { name: "UTC-11", offset: "-11:00" },
    { name: "Venezuela Standard Time", offset: "-04:00" },
    { name: "Vladivostok Standard Time", offset: "+10:00" },
    { name: "Volgograd Standard Time", offset: "+03:00" },
    { name: "W. Australia Standard Time", offset: "+08:00" },
    { name: "W. Central Africa Standard Time", offset: "+01:00" },
    { name: "W. Europe Standard Time", offset: "+02:00" },
    { name: "W. Mongolia Standard Time", offset: "+07:00" },
    { name: "West Asia Standard Time", offset: "+05:00" },
    { name: "West Bank Standard Time", offset: "+03:00" },
    { name: "West Pacific Standard Time", offset: "+10:00" },
    { name: "Yakutsk Standard Time", offset: "+09:00" },
    { name: "Yukon Standard Time", offset: "-07:00" },
  ];

  const validTabsByCompanyType = {
    RETAIL: [0, 1, 2, 3, 4, 5, 6, 7, 8, 11, 12, ...(showImportsPO ? [13] : [])],
    RETAILX: [0, 1, 2, 3, 4, 5, 6, 7, 8, 11, 12],
    RESTO: [0, 1, 4, 7, 8],
    RESTOK: [0, 1, 4, 7, 8],
  };
  const baseValidTabs = validTabsByCompanyType[database.currentCompany.type] || [0];
  const validTabs = acombagoIntegration
    ? baseValidTabs.filter((tabId) => tabId !== 11 && tabId !== 12)
    : baseValidTabs;

  const DEFAULT_SETTINGS = {
    discount_settings: "off",
    tax_option: "default",
    cogs_enabled: "off",
    calculation_formula: "default",
    no_description: "off",
    cc_fees_retail: "off",
    surcharge_retail: "on",
    surcharge_restok: "off",
    NO_DESCRIPTION_PAYMENT_R: "off",
    NO_DESCRIPTION_CATEGORY_R: "off",
    NO_DESCRIPTION_PAYMENT_L: "off",
    NO_DESCRIPTION_CATEGORY_L: "off",
    cash_over_short: "off",
    time_zone: "Eastern Standard Time",
    email_list: "",
    email_send_hour: 0,
    NO_DEFFERED_REVENUE_R: "off",
    restok_option: "business_location",
    show_sum_of_rounds_as_credit: "off",
    show_sum_of_rounds_as_credit_gl_id: "",
    show_sum_of_rounds_as_credit_gl_description: "",
    show_order_profile: "off",
    show_order_tag: "off",
    show_group_statistic: "off",
    show_item_statistic: "off",
    meal_period_enabled: "off",
    meal_period_1_name: "",
    meal_period_1_from_time: "",
    meal_period_1_to_time: "",
    meal_period_2_name: "",
    meal_period_2_from_time: "",
    meal_period_2_to_time: "",
    meal_period_3_name: "",
    meal_period_3_from_time: "",
    meal_period_3_to_time: "",
    meal_period_4_name: "",
    meal_period_4_from_time: "",
    meal_period_4_to_time: "",
    amortized_enabled: "off",
    amortized_rows: [],
  };

  const SETTINGS_KEYS = Object.keys(DEFAULT_SETTINGS);

  const xoption =
    database.currentCompany.type === "RESTOK"
      ? "UI_SETTINGS_SAVE_K"
      : database.currentCompany.type === "RESTO"
      ? "UI_SETTINGS_SAVE_L"
      : "UI_SETTINGS_SAVE_R";

  const xoption2 =
    database.currentCompany.type === "RESTOK"
      ? "UI_SETTINGS_GET_K"
      : database.currentCompany.type === "RESTO"
      ? "UI_SETTINGS_GET_L"
      : "UI_SETTINGS_GET_R";

  const settingsShopId =
    database.currentCompany.type === "RESTOK"
      ? database.currentShop?.area_id ?? 0
      : database.currentShop?.shop_id ?? 0;

  const [settings, setSettings] = useState(DEFAULT_SETTINGS);
  const [settingsLoading, setSettingsLoading] = useState(false);
  const [settingsError, setSettingsError] = useState(null);

  const getValue = (valueOrEvent, fallback = "") => {
    if (
      valueOrEvent &&
      typeof valueOrEvent === "object" &&
      valueOrEvent.target
    ) {
      return valueOrEvent.target.value ?? fallback;
    }

    if (typeof valueOrEvent === "string" || typeof valueOrEvent === "number") {
      return valueOrEvent;
    }

    return fallback;
  };

  const updateSetting = (key, fallback = "") => (valueOrEvent) => {
    const value = getValue(valueOrEvent, fallback);
    setSettings((s) => ({
      ...s,
      [key]: value,
    }));
  };

  const normalizeSettings = (raw) => {
    const safe = {};
    SETTINGS_KEYS.forEach((k) => {
      if (raw && Object.prototype.hasOwnProperty.call(raw, k)) {
        if (k === "email_send_hour") {
          const n = Number(raw[k]);
          safe[k] = Number.isFinite(n) ? n : 0;
        } else if (k === "surcharge_retail") {
          safe[k] = raw[k] === "off" ? "off" : "on";
        } else if (k === "amortized_rows") {
          if (Array.isArray(raw[k])) {
            safe[k] = raw[k];
          } else {
            try {
              const parsedRows = JSON.parse(raw[k] || "[]");
              safe[k] = Array.isArray(parsedRows) ? parsedRows : [];
            } catch (err) {
              safe[k] = [];
            }
          }
        } else {
          safe[k] = String(raw[k]);
        }
      }
    });
    return { ...DEFAULT_SETTINGS, ...safe };
  };

  useEffect(() => {
    if (!showSettings) return;

    const ac = new AbortController();

    (async () => {
      try {
        setSettingsLoading(true);
        setSettingsError(null);

        const data = await fetchSettings({ signal: ac.signal });
        const raw = data?.settings ?? data;
        const nextSettings = normalizeSettings(raw);
        setSettings(nextSettings);
        dispatch(setUiSettings(nextSettings));
      } catch (err) {
        if (err.name !== "AbortError") {
          console.error(err);
          setSettingsError(err.message || "Failed to load settings");
          setSettings(DEFAULT_SETTINGS);
        }
      } finally {
        setSettingsLoading(false);
      }
    })();

    return () => ac.abort();
  }, [showSettings]);

  const fetchSettings = async ({ signal } = {}) => {
    const body = {
      company_id: database.currentCompany.id,
      shop_id: settingsShopId,
      user_id: userState.user.user_id,
      xoption: xoption2,
    };

    const res = await fetch(SETTINGS_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
      signal,
    });

    if (!res.ok) {
      const text = await res.text().catch(() => "");
      throw new Error(`Load failed (${res.status}): ${text}`);
    }

    return res.json();
  };

  useEffect(() => {
    if (
      !database.currentCompany?.type ||
      Number(database.currentCompany?.id) < 0 ||
      !userState.user?.user_id
    ) {
      return;
    }

    const ac = new AbortController();

    (async () => {
      try {
        const data = await fetchSettings({ signal: ac.signal });
        const raw = data?.settings ?? data;
        const nextSettings = normalizeSettings(raw);
        setSettings(nextSettings);
        dispatch(setUiSettings(nextSettings));
      } catch (err) {
        if (err.name !== "AbortError") {
          console.error(err);
          dispatch(setUiSettings(DEFAULT_SETTINGS));
        }
      }
    })();

    return () => ac.abort();
  }, [
    database.currentCompany?.id,
    database.currentCompany?.type,
    database.currentShop?.shop_id,
    userState.user?.user_id,
    dispatch,
  ]);

  const saveSettings = async (payload) => {
    const body = {
      company_id: database.currentCompany.id,
      shop_id: settingsShopId,
      user_id: userState.user.user_id,
      xoption,
      settings: {
        ...payload,
        time_zone: payload.time_zone || "Eastern Standard Time",
        email_list:
          typeof emailList === "string" ? emailList : payload.email_list ?? "",
        email_send_hour: Number.isFinite(+timeSelection) ? +timeSelection : 0,
      },
    };

    const res = await fetch(SETTINGS_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });

    if (!res.ok) {
      const text = await res.text().catch(() => "");
      throw new Error(`Save failed (${res.status}): ${text}`);
    }

    return res.json();
  };

  useEffect(() => {
    if (!showSettings) return;

    setEmailList(settings.email_list || "");
    setTimeSelection(
      String(
        Number.isFinite(Number(settings.email_send_hour))
          ? Number(settings.email_send_hour)
          : 0
      )
    );
  }, [showSettings, settings.email_list, settings.email_send_hour]);

  useEffect(() => {
    if (ui?.settings) setSettings(ui.settings);
  }, [ui?.settings]);

  useEffect(() => {
    const savedTab = parseInt(localStorage.getItem("currentTable"), 10);

    if (!isNaN(savedTab) && validTabs.includes(savedTab)) {
      dispatch(setCurrentTable(savedTab));
    } else {
      dispatch(setCurrentTable(validTabs[0]));
    }
  }, [database.currentCompany.type, acombagoIntegration, showImportsPO, dispatch]);

  useEffect(() => {
    localStorage.setItem("currentTable", ui.table);
  }, [ui.table]);

  const openTabInfo = (event, title, description, maxWidth) => {
    event.preventDefault();
    event.stopPropagation();
    setTabInfo({ title, description, maxWidth });
  };
  const closeSettingsModal = () => {
    if (tabInfo) {
      setTabInfo(null);
      return;
    }

    setShowSettings(false);
  };

  const settingsInfoStyle = {
    color: "#fff",
    backgroundColor: "#2563eb",
    borderColor: "#2563eb",
    width: 22,
    height: 22,
    fontSize: 14,
    lineHeight: "22px",
    opacity: 1,
  };

  const renderSettingsInfo = (title, description, maxWidth) => (
    <Tip
      title={title}
      onClick={(event) => openTabInfo(event, title, description, maxWidth)}
      style={settingsInfoStyle}
    />
  );

  const renderInfoImage = (src, alt) => (
    <button
      type="button"
      onClick={() => setEnlargedImage({ src, alt })}
      style={{
        border: "none",
        padding: 0,
        background: "transparent",
        cursor: "zoom-in",
        textAlign: "left",
      }}
      aria-label={"Enlarge " + alt}
    >
      <img
        src={src}
        alt={alt}
        style={{
          width: "100%",
          maxHeight: "72vh",
          objectFit: "contain",
          border: "1px solid #e5e7eb",
          borderRadius: 6,
          background: "#fff",
          display: "block",
        }}
      />
    </button>
  );

  const settingsAgendaItems = {
    A: { label: "Visual", color: "#2563eb", background: "#eff6ff", border: "#bfdbfe" },
    B: { label: "Affect Data Posting", color: "#f97316", background: "#fff7ed", border: "#fed7aa" },
    C: { label: "Affect Mapping", color: "#7c3aed", background: "#f5f3ff", border: "#ddd6fe" },
  };

  const renderSettingsGroupBadges = (icons) => (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 3 }}>
      {icons.map((icon) => {
        const item = settingsAgendaItems[icon];
        return (
          <span
            key={icon}
            aria-label={item.label}
            title={item.label}
            style={{
              width: 18,
              height: 18,
              borderRadius: "50%",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              border: `1px solid ${item.border}`,
              background: item.color,
              color: "#fff",
              fontSize: 10,
              fontWeight: 900,
              lineHeight: 1,
            }}
          >
            {icon}
          </span>
        );
      })}
    </span>
  );
  const renderSettingsAgenda = (compact = false) => {
    const items = [
      { icon: "A", label: "VISUAL", ...settingsAgendaItems.A },
      { icon: "B", label: "AFFECT DATA POSTING", ...settingsAgendaItems.B },
      { icon: "C", label: "AFFECT MAPPING", ...settingsAgendaItems.C },
    ];

    return (
      <div
        style={{
          alignSelf: "start",
          justifySelf: compact ? "start" : "stretch",
          minWidth: 0,
          width: compact ? "auto" : "100%",
          display: compact ? "inline-flex" : "grid",
          flexWrap: "wrap",
          justifyContent: compact ? "flex-start" : "flex-end",
          gap: compact ? 6 : 12,
          padding: compact ? "0 2px 6px" : 14,
          border: compact ? "none" : "1px solid #e5e7eb",
          borderRadius: compact ? 0 : 8,
          background: compact ? "transparent" : "#fff",
          boxShadow: compact ? "none" : "0 1px 2px rgba(15, 23, 42, 0.06)",
          fontSize: compact ? 9 : 12,
          fontWeight: 800,
          color: "#0f172a",
        }}
      >
        {items.map((item) => (
          <div
            key={item.icon}
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 10,
              justifySelf: "stretch",
              width: compact ? "auto" : "100%",
              padding: compact ? "3px 7px 3px 3px" : "6px 12px 6px 6px",
              border: `1px solid ${item.border}`,
              borderRadius: 999,
              background: item.background,
              whiteSpace: "nowrap",
            }}
          >
            <span
              aria-hidden="true"
              style={{
                width: compact ? 16 : 22,
                height: compact ? 16 : 22,
                borderRadius: "50%",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                background: item.color,
                color: "#fff",
                fontSize: compact ? 9 : 12,
                fontWeight: 900,
              }}
            >
              {item.icon}
            </span>
            <span>{item.label}</span>
          </div>
        ))}
      </div>
    );
  };

  const getAmortizedRows = () =>
    Array.isArray(settings.amortized_rows) ? settings.amortized_rows : [];

  const getAmortizedDisplayRows = () => {
    const rows = getAmortizedRows();
    if (rows.length >= 10) return rows;

    return [
      ...rows,
      ...Array.from({ length: 10 - rows.length }, () => ({ ...emptyAmortizedRow })),
    ];
  };

  const currentRetailCategories = Array.isArray(database.currentShop?.categories)
    ? database.currentShop.categories
    : [];
  const currentRetailShopId = database.currentShop?.shop_id ?? null;
  const cachedRetailCategories = Array.isArray(
    database.retailCategoriesByShop?.[String(currentRetailShopId)]
  )
    ? database.retailCategoriesByShop[String(currentRetailShopId)]
    : [];

  const categoryOptions = currentRetailCategories.length
    ? currentRetailCategories
    : cachedRetailCategories;

  const emptyAmortizedRow = {
    category_id: "",
    category_name: "",
    itemid: "",
    item_name: "",
    start_date: "",
    end_date: "",
  };

  const updateAmortizedRow = (index, patch) => {
    setSettings((s) => {
      const rows = Array.isArray(s.amortized_rows) ? s.amortized_rows : [];
      const nextRows = [...rows];
      while (nextRows.length <= index) nextRows.push({ ...emptyAmortizedRow });
      nextRows[index] = { ...emptyAmortizedRow, ...(nextRows[index] || {}), ...patch };
      return { ...s, amortized_rows: nextRows };
    });
  };

  const addAmortizedRow = () => {
    setSettings((s) => ({
      ...s,
      amortized_rows: [
        ...Array.from(
          { length: Math.max(10, Array.isArray(s.amortized_rows) ? s.amortized_rows.length : 0) },
          (_, index) => ({
            ...emptyAmortizedRow,
            ...((Array.isArray(s.amortized_rows) && s.amortized_rows[index]) || {}),
          })
        ),
        { ...emptyAmortizedRow },
      ],
    }));
  };

  const removeAmortizedRow = (index) => {
    setSettings((s) => {
      const rows = Array.isArray(s.amortized_rows) ? s.amortized_rows : [];
      const nextRows = rows.filter((_, rowIndex) => rowIndex !== index);
      return { ...s, amortized_rows: nextRows };
    });
  };

  const fetchAmortizedItems = async (categoryId) => {
    const categoryKey = String(categoryId || "");
    if (!categoryKey) return;

    setAmortizedItemsLoading((current) => ({ ...current, [categoryKey]: true }));
    setAmortizedItemsError((current) => ({ ...current, [categoryKey]: "" }));

    try {
      const response = await fetch(`${serverUrl}/api/list/retail/items`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          token_company_id: database.currentCompany.id,
          token_user_id: `${categoryId}:AMORTIZED|${userState.user.user_id}`,
          token_shop_id: settingsShopId,
          token_category_id: categoryId,
          operation_id: "AmortizeItemList",
        }),
      });

      if (!response.ok) {
        const message = await response.text().catch(() => "");
        throw new Error(`Items request failed (${response.status}): ${message}`);
      }

      const payload = await response.json();
      const items = Array.isArray(payload)
        ? payload
        : Array.isArray(payload?.items)
          ? payload.items
          : [];
      const responseHasCategoryIds = items.some(
        (item) => item?.category_id !== undefined && item?.category_id !== null
      );
      const categoryItems = responseHasCategoryIds
        ? items.filter((item) => String(item.category_id) === categoryKey)
        : items;

      setAmortizedItemsByCategory((current) => ({
        ...current,
        [categoryKey]: categoryItems,
      }));
    } catch (error) {
      console.error(error);
      setAmortizedItemsByCategory((current) => ({ ...current, [categoryKey]: [] }));
      setAmortizedItemsError((current) => ({
        ...current,
        [categoryKey]: error.message || "Failed to load items",
      }));
    } finally {
      setAmortizedItemsLoading((current) => ({ ...current, [categoryKey]: false }));
    }
  };

  const fetchAmortizedCategories = async () => {
    const response = await fetch(`${serverUrl}/api/list/retail/categories`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        token_company_id: database.currentCompany.id,
        token_user_id: userState.user.user_id,
        token_shop_id: settingsShopId,
      }),
    });

    if (!response.ok) {
      const message = await response.text().catch(() => "");
      throw new Error(`Categories request failed (${response.status}): ${message}`);
    }

    const payload = await response.json();
    const categories = Array.isArray(payload)
      ? payload
      : Array.isArray(payload?.categories)
        ? payload.categories
        : [];

    dispatch(databaseActions.setShopCategories(categories, settingsShopId));
    return categories;
  };

  const selectAmortizedItem = (index, categoryId, itemId) => {
    const selected = (amortizedItemsByCategory[String(categoryId)] || []).find(
      (item) => String(item?.itemid ?? "") === String(itemId ?? "")
    );
    updateAmortizedRow(index, {
      itemid: selected?.itemid || itemId,
      item_name: selected?.description || "",
    });
  };

  const amortizedDescription = (
    <div style={{ display: "grid", gap: 10 }}>
      <p style={{ margin: 0 }}>
        Activate this feature to amortize a selected item over a monthly cycle.
      </p>
      <p style={{ margin: 0 }}>
        Select the contributing category, choose the item, then define the start
        and end dates for the amortized period. Sales are recognized monthly
        based on that date range.
      </p>
    </div>
  );

  const openAmortizedSettings = async () => {
    if (amortizedSettingsLoading) return;

    try {
      setAmortizedSettingsLoading(true);
      setSaveError(null);
      setSaveSuccess(false);

      const [data] = await Promise.all([
        fetchSettings(),
        fetchAmortizedCategories(),
      ]);
      const raw = data?.settings ?? data;
      const nextSettings = normalizeSettings(raw);
      const rows = Array.isArray(nextSettings.amortized_rows)
        ? nextSettings.amortized_rows
        : [];

      setSettings((current) => ({
        ...current,
        amortized_enabled: nextSettings.amortized_enabled,
        amortized_rows: rows,
      }));
      setAmortizedSnapshot({
        amortized_enabled: nextSettings.amortized_enabled,
        amortized_rows: rows.map((row) => ({ ...row })),
      });
      setAmortizedItemsByCategory({});
      setAmortizedItemsLoading({});
      setAmortizedItemsError({});
      setShowAmortizedSettings(true);

      [...new Set(rows.map((row) => row.category_id).filter(Boolean))].forEach(
        fetchAmortizedItems
      );
    } catch (error) {
      console.error(error);
      setSaveError(error.message || "Failed to load Amortized settings");
    } finally {
      setAmortizedSettingsLoading(false);
    }
  };

  const closeAmortizedSettings = () => {
    if (amortizedSnapshot) {
      setSettings((current) => ({
        ...current,
        amortized_enabled: amortizedSnapshot.amortized_enabled,
        amortized_rows: amortizedSnapshot.amortized_rows.map((row) => ({ ...row })),
      }));
    }
    setAmortizedSnapshot(null);
    setShowAmortizedSettings(false);
  };

  const renderAmortizedEditor = () => (
    <div style={{ display: "grid", gridTemplateColumns: "minmax(230px, 300px) minmax(700px, 1fr)", gap: 16, minWidth: 960 }}>
      <div style={{ border: "1px solid #fbcfe8", borderRadius: 6, padding: 16, background: "#fff7fb", display: "grid", gap: 14, alignContent: "start" }}>
        <div style={{ fontSize: 13, fontWeight: 700, lineHeight: 1.5, display: "flex", alignItems: "flex-start", gap: 8 }}>
          <span style={{ flex: 1 }}>
            Activate this feature to amortize any payment associated to an item that should be recognized over time. The cycle is monthly.
          </span>
          {renderSettingsInfo("Amortized", amortizedDescription, 760)}
        </div>
        <div style={{ display: "flex", flexWrap: "wrap", gap: "8px 18px" }}>
          <label><input type="radio" name="amortized_enabled_modal" value="on" checked={settings.amortized_enabled === "on"} onChange={updateSetting("amortized_enabled", "off")} />{" "}on</label>
          <label><input type="radio" name="amortized_enabled_modal" value="off" checked={settings.amortized_enabled === "off"} onChange={updateSetting("amortized_enabled", "off")} />{" "}off</label>
        </div>
      </div>

      <div style={{ border: "1px solid #fbcfe8", borderRadius: 6, padding: 16, background: "#fff", display: "grid", gap: 10 }}>
        <div style={{ display: "grid", gridTemplateColumns: "minmax(180px, 1fr) minmax(220px, 1.2fr) 145px 145px 74px", gap: 10, alignItems: "center", fontWeight: 800, fontSize: 11, color: "#831843" }}>
          <div>Category</div>
          <div>Item name</div>
          <div>Start date</div>
          <div>End date</div>
          <div />
        </div>

        {getAmortizedDisplayRows().map((row, index) => (
          <div key={`amortized-modal-row-${index}`} style={{ display: "grid", gridTemplateColumns: "minmax(180px, 1fr) minmax(220px, 1.2fr) 145px 145px 74px", gap: 10, alignItems: "center" }}>
            <select
              value={row.category_id || ""}
              onChange={(event) => {
                const categoryId = getValue(event, "");
                const selected = categoryOptions.find(
                  (category) => String(category?.category_id ?? "") === String(categoryId)
                );
                updateAmortizedRow(index, {
                  category_id: selected?.category_id || categoryId,
                  category_name: selected?.category_name || "",
                  itemid: "",
                  item_name: "",
                });
                if (categoryId) fetchAmortizedItems(categoryId);
              }}
              style={{ width: "100%", minWidth: 0, padding: "9px 10px", borderRadius: 6, border: "1px solid #f9a8d4" }}
            >
              <option value="">Select category</option>
              {row.category_id && !categoryOptions.some((category) => String(category?.category_id ?? "") === String(row.category_id)) && (
                <option value={row.category_id}>
                  {row.category_name ? `${row.category_id} - ${row.category_name}` : row.category_id}
                </option>
              )}
              {categoryOptions.map((category) => (
                <option key={`${category.category_id}-${category.category_name}`} value={category.category_id || ""}>
                  {category.category_name
                    ? `${category.category_id} - ${category.category_name}`
                    : category.category_id}
                </option>
              ))}
            </select>
            <select
              value={row.itemid || ""}
              disabled={!row.category_id || amortizedItemsLoading[String(row.category_id)]}
              title={amortizedItemsError[String(row.category_id)] || ""}
              onChange={(event) => selectAmortizedItem(index, row.category_id, getValue(event, ""))}
              style={{ width: "100%", minWidth: 0, padding: "9px 10px", borderRadius: 6, border: "1px solid #f9a8d4" }}
            >
              <option value="">
                {!row.category_id
                  ? "Select category first"
                  : amortizedItemsLoading[String(row.category_id)]
                    ? "Loading items..."
                    : amortizedItemsError[String(row.category_id)]
                      ? "Failed to load items"
                      : "Select item"}
              </option>
              {row.itemid && !(amortizedItemsByCategory[String(row.category_id)] || []).some((item) => String(item?.itemid ?? "") === String(row.itemid)) && (
                <option value={row.itemid}>
                  {row.item_name ? `${row.itemid} - ${row.item_name}` : row.itemid}
                </option>
              )}
              {(amortizedItemsByCategory[String(row.category_id)] || []).map((item) => (
                <option key={`${row.category_id}-${item.itemid}`} value={item.itemid || ""}>
                  {item.description ? `${item.itemid} - ${item.description}` : item.itemid}
                </option>
              ))}
            </select>
            <input
              type="date"
              value={row.start_date || ""}
              onChange={(event) => updateAmortizedRow(index, { start_date: getValue(event, "") })}
              style={{ width: "100%", minWidth: 0, padding: "8px", borderRadius: 6, border: "1px solid #f9a8d4" }}
            />
            <input
              type="date"
              value={row.end_date || ""}
              onChange={(event) => updateAmortizedRow(index, { end_date: getValue(event, "") })}
              style={{ width: "100%", minWidth: 0, padding: "8px", borderRadius: 6, border: "1px solid #f9a8d4" }}
            />
            <div style={{ display: "flex", justifyContent: "flex-end", gap: 6 }}>
              <button
                type="button"
                onClick={() => removeAmortizedRow(index)}
                title="Delete row"
                aria-label="Delete amortized row"
                style={{ width: 32, height: 32, borderRadius: 6, border: "1px solid #f9a8d4", background: "#ef4444", color: "#fff", display: "inline-flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}
              >
                <FaTrash />
              </button>
              {index === (getAmortizedDisplayRows().length - 1) && (
                <button
                  type="button"
                  onClick={addAmortizedRow}
                  title="Add row"
                  aria-label="Add amortized row"
                  style={{ width: 32, height: 32, borderRadius: "50%", border: "1px solid #0f766e", background: "#14b8a6", color: "#fff", display: "inline-flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}
                >
                  <FaPlus />
                </button>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  useEffect(() => {
    if (!tabInfo) return undefined;

    const handleInfoEscape = (event) => {
      if (event.key !== "Escape") return;

      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === "function") {
        event.stopImmediatePropagation();
      }
      setTabInfo(null);
    };

    document.addEventListener("keydown", handleInfoEscape, true);

    return () => {
      document.removeEventListener("keydown", handleInfoEscape, true);
    };
  }, [tabInfo]);

  useEffect(() => {
    if (!enlargedImage) return undefined;

    const handleImageEscape = (event) => {
      if (event.key !== "Escape") return;
      setEnlargedImage(null);
    };

    document.addEventListener("keydown", handleImageEscape);

    return () => {
      document.removeEventListener("keydown", handleImageEscape);
    };
  }, [enlargedImage]);

  const taxClassAllocationDescription = (
    <div style={{ marginTop: 18 }}>
      <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 8 }}>Tax Class Allocation</div>
      <p style={{ margin: "0 0 12px" }}>
        The POS system provides a single aggregated tax amount for each transaction.
        To support accounting requirements, the total tax amount is automatically
        allocated across multiple tax classes based on their configured tax rates.
      </p>
      <p style={{ margin: "0 0 12px" }}>
        The allocation is performed proportionally using the percentages defined in
        the Tax Class Allocation setup. Each allocated amount is then posted to its
        corresponding GL account.
      </p>
      <div style={{ fontWeight: 700, margin: "16px 0 8px" }}>Mapping Configuration</div>
      <p style={{ margin: "0 0 8px" }}>
        To enable Tax Class Allocation, create mappings using the following descriptions:
      </p>
      <ul style={{ margin: "0 0 12px", paddingLeft: 18 }}>
        <li>TAX-CLASS: 1</li>
        <li>TAX-CLASS: 2</li>
        <li>TAX-CLASS: 3</li>
        <li>TAX-CLASS: 4</li>
        <li>TAX-CLASS: 5</li>
        <li>TAX-CLASS: 6</li>
      </ul>
      <p style={{ margin: "0 0 12px" }}>
        The number of mappings required depends on the number of tax classes that
        make up the total tax rate.
      </p>
      <p style={{ margin: "0 0 6px", fontWeight: 600 }}>Examples:</p>
      <p style={{ margin: "0 0 6px" }}>
        If the total tax consists of 2 tax components, map:
      </p>
      <ul style={{ margin: "0 0 12px", paddingLeft: 18 }}>
        <li>TAX-CLASS: 1</li>
        <li>TAX-CLASS: 2</li>
      </ul>
      <p style={{ margin: "0 0 6px" }}>
        If the total tax consists of 5 tax components, map:
      </p>
      <ul style={{ margin: "0 0 12px", paddingLeft: 18 }}>
        <li>TAX-CLASS: 1</li>
        <li>TAX-CLASS: 2</li>
        <li>TAX-CLASS: 3</li>
        <li>TAX-CLASS: 4</li>
        <li>TAX-CLASS: 5</li>
      </ul>
      <p style={{ margin: "0 0 8px" }}>For each TAX-CLASS mapping:</p>
      <ul style={{ margin: "0 0 12px", paddingLeft: 18 }}>
        <li>Description = TAX-CLASS: X</li>
        <li>Tax Class Allocation = Tax percentage for that tax component</li>
        <li>Account = GL account where that portion of the tax should be posted</li>
      </ul>
      <p style={{ margin: "0 0 8px", fontWeight: 600 }}>Example Configuration:</p>
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          marginBottom: 12,
          fontSize: 13,
        }}
      >
        <thead>
          <tr>
            <th style={{ textAlign: "left", borderBottom: "1px solid #cbd5e1", padding: "6px 8px" }}>
              Description
            </th>
            <th style={{ textAlign: "right", borderBottom: "1px solid #cbd5e1", padding: "6px 8px" }}>
              Tax Class Allocation
            </th>
            <th style={{ textAlign: "left", borderBottom: "1px solid #cbd5e1", padding: "6px 8px" }}>
              GL Account
            </th>
          </tr>
        </thead>
        <tbody>
          {[
            ["TAX-CLASS: 1", "6.875", "101-0000-209-0100"],
            ["TAX-CLASS: 2", "0.250", "101-0000-209-0600"],
            ["TAX-CLASS: 3", "0.750", "101-0000-209-0900"],
            ["TAX-CLASS: 4", "0.150", "101-0000-209-0700"],
            ["TAX-CLASS: 5", "0.500", "101-0000-209-0210"],
          ].map(([description, allocation, glAccount]) => (
            <tr key={description}>
              <td style={{ padding: "6px 8px", borderBottom: "1px solid #e2e8f0" }}>
                {description}
              </td>
              <td style={{ padding: "6px 8px", borderBottom: "1px solid #e2e8f0", textAlign: "right" }}>
                {allocation}
              </td>
              <td style={{ padding: "6px 8px", borderBottom: "1px solid #e2e8f0" }}>
                {glAccount}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <p style={{ margin: "0 0 12px", fontWeight: 600 }}>
        Total Combined Tax Rate: 8.525%
      </p>
      <p style={{ margin: "0 0 12px" }}>
        If the POS reports a total tax amount of $43.85, the system allocates
        the tax proportionally across all configured tax classes and posts each
        portion to its corresponding GL account.
      </p>
      <p style={{ margin: 0 }}>
        This allows individual tax jurisdictions or tax liabilities to be
        tracked and reported separately while still receiving a single
        aggregated tax amount from the POS system.
      </p>
    </div>
  );

  const taxOptionDescription = (
    <>
      <p style={{ margin: "0 0 12px" }}>
        Select how taxes are applied and grouped in Retail reports and journal entries.
      </p>
      <ul style={{ margin: 0, paddingLeft: 18 }}>
        <li>
          <strong>default</strong> - use the standard tax posting behavior.
        </li>
        <li>
          <strong>NO_TAX</strong> - post without tax allocation.
        </li>
        <li>
          <strong>TAX-CLASS-TAX1-TAX2</strong> - split tax by class and tax codes.
        </li>
        <li>
          <strong>TAX_CLASS_A_2_SEPARATED</strong> - separate tax class A 2 rules.
        </li>
        <li>
          <strong>Tax Class Allocation</strong> - allocate one aggregated POS tax amount
          across configured tax classes.
        </li>
      </ul>
      {taxClassAllocationDescription}
    </>
  );
  const discountDescription = (
    <div style={{ display: "grid", gap: 14 }}>
      <p style={{ margin: 0 }}>
        Choose how discounts are grouped in the report: by type, by category, as a summary, or disabled.
      </p>
      {renderInfoImage("/DiscountInfo.jpg", "Discount settings example")}
      {renderInfoImage("/DiscountInfo2.jpg", "Discount settings example 2")}
    </div>
  );
  const cogsDescription = (
    <div style={{ display: "grid", gap: 14 }}>
      <p style={{ margin: 0 }}>
        Use Show COGS when Cost of Goods Sold needs to be included in the journal export.
      </p>
      <ul style={{ margin: 0, paddingLeft: 18 }}>
        <li>
          <strong>COGS Total</strong> is used for summing the total COGS amount.
        </li>
        <li>
          <strong>COGS</strong> is used for grouping COGS by GL ID.
        </li>
        <li>
          This keeps the report balanced so total debit equals total credit.
        </li>
      </ul>
      <img
        src="/CogsInfo.jpg"
        alt="COGS total and COGS grouping example"
        style={{
          width: "100%",
          maxHeight: "72vh",
          objectFit: "contain",
          border: "1px solid #e5e7eb",
          borderRadius: 6,
          background: "#fff",
        }}
      />
    </div>
  );
  const paymentWithoutDescriptionDescription = (
    <div style={{ display: "grid", gap: 14 }}>
      <p style={{ margin: 0 }}>
        When enabled, the report will not display the payment name in the posting_comment column.
      </p>

      <div style={{ display: "grid", gap: 8 }}>
        <div style={{ fontWeight: 700 }}>Off - payment names are shown</div>
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
          <thead>
            <tr>
              {["transaction_date", "account_id", "account_description", "debit", "credit", "posting_comment", "xoption", "Totals"].map((column) => (
                <th
                  key={column}
                  style={{
                    background: "#dbeafe",
                    border: column === "posting_comment" ? "3px solid #ef4444" : "1px solid #bfdbfe",
                    padding: "5px 6px",
                    textAlign: column === "debit" || column === "credit" || column === "Totals" ? "right" : "left",
                    whiteSpace: "nowrap",
                  }}
                >
                  {column}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {[
              ["2026-08-07", "1071", "Credit Card", "50.02", "0.00", "Amex", "payments", "50.02"],
              ["2026-08-07", "1071", "Credit Card", "61.00", "0.00", "Visa", "payments", "61.00"],
              ["Totals", "", "", "111.02", "0.00", "", "", "111.02"],
            ].map((row, rowIndex) => (
              <tr key={`payment-off-${rowIndex}`}>
                {row.map((value, columnIndex) => (
                  <td
                    key={`${value}-${columnIndex}`}
                    style={{
                      background: rowIndex === 2 ? "#fef3c7" : "#eaf2ff",
                      border: columnIndex === 5 ? "3px solid #ef4444" : "1px solid #bfdbfe",
                      padding: "5px 6px",
                      fontWeight: columnIndex >= 3 || rowIndex === 2 ? 700 : 600,
                      textAlign: columnIndex === 0 && rowIndex === 2 ? "right" : columnIndex === 3 || columnIndex === 4 || columnIndex === 7 ? "right" : "left",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {value}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div style={{ display: "grid", gap: 8 }}>
        <div style={{ fontWeight: 700 }}>On - payment names are hidden and summarized</div>
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
          <thead>
            <tr>
              {["transaction_date", "account_id", "account_description", "debit", "credit", "posting_comment", "xoption", "Totals"].map((column) => (
                <th
                  key={column}
                  style={{
                    background: "#dbeafe",
                    border: "1px solid #bfdbfe",
                    padding: "5px 6px",
                    textAlign: column === "debit" || column === "credit" || column === "Totals" ? "right" : "left",
                    whiteSpace: "nowrap",
                  }}
                >
                  {column}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {[
              ["2026-08-07", "1071", "Credit Card", "111.02", "0.00", "", "payments", "111.02"],
              ["Totals", "", "", "111.02", "0.00", "", "", "111.02"],
            ].map((row, rowIndex) => (
              <tr key={`payment-on-${rowIndex}`}>
                {row.map((value, columnIndex) => (
                  <td
                    key={`${value}-${columnIndex}`}
                    style={{
                      background: rowIndex === 1 ? "#fef3c7" : "#eaf2ff",
                      border: "1px solid #bfdbfe",
                      padding: "5px 6px",
                      fontWeight: columnIndex >= 3 || rowIndex === 1 ? 700 : 600,
                      textAlign: columnIndex === 0 && rowIndex === 1 ? "right" : columnIndex === 3 || columnIndex === 4 || columnIndex === 7 ? "right" : "left",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {value}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );


  const categoryWithoutDescriptionDescription = (
    <div style={{ display: "grid", gap: 14 }}>
      <p style={{ margin: 0 }}>
        When enabled, the report will not display the accounting group name in the posting_comment column.
      </p>

      <div style={{ display: "grid", gap: 8 }}>
        <div style={{ fontWeight: 700 }}>Off - category names are shown</div>
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
          <thead>
            <tr>
              {["transaction_date", "account_id", "account_description", "debit", "credit", "posting_comment", "xoption", "Totals"].map((column) => (
                <th
                  key={column}
                  style={{
                    background: "#dbeafe",
                    border: column === "posting_comment" ? "3px solid #ef4444" : "1px solid #bfdbfe",
                    padding: "5px 6px",
                    textAlign: column === "debit" || column === "credit" || column === "Totals" ? "right" : "left",
                    whiteSpace: "nowrap",
                  }}
                >
                  {column}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {[
              ["2026-08-07", "4170", "Beer-restaurant Food & Beverage", "0.00", "41.00", "Food", "sales", "-41.00"],
              ["2026-08-07", "4170", "Beer-restaurant Food & Beverage", "0.00", "50.00", "Craft Beer", "sales", "-50.00"],
              ["Totals", "", "", "0.00", "91.00", "", "", "-91.00"],
            ].map((row, rowIndex) => (
              <tr key={`category-off-${rowIndex}`}>
                {row.map((value, columnIndex) => (
                  <td
                    key={`${value}-${columnIndex}`}
                    style={{
                      background: rowIndex === 2 ? "#fef3c7" : "#eaf2ff",
                      border: columnIndex === 5 ? "3px solid #ef4444" : "1px solid #bfdbfe",
                      padding: "5px 6px",
                      fontWeight: columnIndex >= 3 || rowIndex === 2 ? 700 : 600,
                      textAlign: columnIndex === 0 && rowIndex === 2 ? "right" : columnIndex === 3 || columnIndex === 4 || columnIndex === 7 ? "right" : "left",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {value}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div style={{ display: "grid", gap: 8 }}>
        <div style={{ fontWeight: 700 }}>On - category names are hidden and summarized</div>
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
          <thead>
            <tr>
              {["transaction_date", "account_id", "account_description", "debit", "credit", "posting_comment", "xoption", "Totals"].map((column) => (
                <th
                  key={column}
                  style={{
                    background: "#dbeafe",
                    border: "1px solid #bfdbfe",
                    padding: "5px 6px",
                    textAlign: column === "debit" || column === "credit" || column === "Totals" ? "right" : "left",
                    whiteSpace: "nowrap",
                  }}
                >
                  {column}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {[
              ["2026-08-07", "4170", "Beer-restaurant Food & Beverage", "0.00", "91.00", "", "sales", "-91.00"],
              ["Totals", "", "", "0.00", "91.00", "", "", "-91.00"],
            ].map((row, rowIndex) => (
              <tr key={`category-on-${rowIndex}`}>
                {row.map((value, columnIndex) => (
                  <td
                    key={`${value}-${columnIndex}`}
                    style={{
                      background: rowIndex === 1 ? "#fef3c7" : "#eaf2ff",
                      border: "1px solid #bfdbfe",
                      padding: "5px 6px",
                      fontWeight: columnIndex >= 3 || rowIndex === 1 ? 700 : 600,
                      textAlign: columnIndex === 0 && rowIndex === 1 ? "right" : columnIndex === 3 || columnIndex === 4 || columnIndex === 7 ? "right" : "left",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {value}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );

  const roundsCreditDescription = (
    <div style={{ display: "grid", gap: 14 }}>
      <p style={{ margin: 0 }}>
        If enabled, the sum of rounds is posted as an additional credit line using the configured GL Id and GL Description.
      </p>

      <div style={{ display: "grid", gap: 8 }}>
        <div style={{ fontWeight: 700 }}>On - credit line is added</div>
        <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
          <input value="8002" readOnly style={{ width: 120, padding: "7px 10px", borderRadius: 4, border: "1px solid #cbd5e1" }} />
          <input value="GL_ROUNSSUM_NAME" readOnly style={{ width: 180, padding: "7px 10px", borderRadius: 4, border: "1px solid #cbd5e1" }} />
        </div>
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
          <thead>
            <tr>
              {["transaction_date", "account_id", "account_description", "debit", "credit", "posting_comment", "xoption", "Totals"].map((column) => (
                <th key={column} style={{ background: "#dbeafe", border: "1px solid #bfdbfe", padding: "5px 6px", textAlign: column === "debit" || column === "credit" || column === "Totals" ? "right" : "left", whiteSpace: "nowrap" }}>
                  {column}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {[
              ["2026-08-07", "8001", "Green Fees", "72.00", "0.00", "", "ROUNDS", "72.00"],
              ["2026-08-07", "8002", "GL_ROUNSSUM_NAME", "0.00", "72.00", "", "ROUNDS Total", "-72.00"],
              ["Totals", "", "", "72.00", "72.00", "", "", "0.00"],
            ].map((row, rowIndex) => (
              <tr key={`rounds-on-${rowIndex}`}>
                {row.map((value, columnIndex) => (
                  <td
                    key={`${value}-${columnIndex}`}
                    style={{
                      background: rowIndex === 2 ? "#fef3c7" : "#eaf2ff",
                      border: rowIndex === 1 && (columnIndex === 1 || columnIndex === 2 || columnIndex === 3 || columnIndex === 4) ? "3px solid #ef4444" : "1px solid #bfdbfe",
                      padding: "5px 6px",
                      fontWeight: columnIndex >= 3 || rowIndex === 2 ? 700 : 600,
                      textAlign: columnIndex === 0 && rowIndex === 2 ? "right" : columnIndex === 3 || columnIndex === 4 || columnIndex === 7 ? "right" : "left",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {value}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div style={{ display: "grid", gap: 8 }}>
        <div style={{ fontWeight: 700 }}>Off - no credit line is added</div>
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
          <thead>
            <tr>
              {["transaction_date", "account_id", "account_description", "debit", "credit", "posting_comment", "xoption", "Totals"].map((column) => (
                <th key={column} style={{ background: "#dbeafe", border: "1px solid #bfdbfe", padding: "5px 6px", textAlign: column === "debit" || column === "credit" || column === "Totals" ? "right" : "left", whiteSpace: "nowrap" }}>
                  {column}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {[
              ["2026-08-07", "8001", "Green Fees", "72.00", "0.00", "", "ROUNDS", "72.00"],
              ["Totals", "", "", "72.00", "0.00", "", "", "72.00"],
            ].map((row, rowIndex) => (
              <tr key={`rounds-off-${rowIndex}`}>
                {row.map((value, columnIndex) => (
                  <td
                    key={`${value}-${columnIndex}`}
                    style={{
                      background: rowIndex === 1 ? "#fef3c7" : "#eaf2ff",
                      border: "1px solid #bfdbfe",
                      padding: "5px 6px",
                      fontWeight: columnIndex >= 3 || rowIndex === 1 ? 700 : 600,
                      textAlign: columnIndex === 0 && rowIndex === 1 ? "right" : columnIndex === 3 || columnIndex === 4 || columnIndex === 7 ? "right" : "left",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {value}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
  const restaurantKReportDescription = (
    <div style={{ display: "grid", gap: 18 }}>
      <p style={{ margin: 0 }}>
        Opens Restaurant (K) reporting and export tools. These examples show where
        the optional K-series reporting fields come from.
      </p>

      {[
        ["order_tag", kSeriesOrderTagImage],
        ["statistic_group_id", kSeriesStatisticGroupImage],
        ["statistic_item_id", kSeriesStatisticItemImage],
      ].map(([title, image]) => (
        <div key={title} style={{ display: "grid", gap: 8 }}>
          <div style={{ fontWeight: 700 }}>{title}</div>
          <img
            src={image}
            alt={title}
            style={{
              width: "100%",
              maxHeight: 420,
              objectFit: "contain",
              border: "1px solid #e5e7eb",
              borderRadius: 6,
              background: "#fff",
            }}
          />
        </div>
      ))}
    </div>
  );

  const renderTab = (tabId, label, onClick, info) => (
    <Tab
      className={`modern-tab ${ui.table === tabId ? "modern-tab-active" : ""}`}
      active={ui.table === tabId}
      onClick={onClick}
    >
      {label}
      {info && (
        <>
          {" "}
          <span
            aria-label={`${info.title} info`}
            role="button"
            tabIndex={0}
            onClick={(event) => openTabInfo(event, info.title, info.description, info.maxWidth)}
            onKeyDown={(event) => {
              if (event.key === "Enter" || event.key === " ") {
                openTabInfo(event, info.title, info.description, info.maxWidth);
              }
            }}
            style={{
              display: "inline-block",
              marginLeft: 4,
              verticalAlign: "middle",
              cursor: "pointer",
            }}
          >
            <FaInfoCircle />
          </span>
        </>
      )}
    </Tab>
  );

  const paymentMappingDescription = (
    <>
      <div style={{ fontWeight: 700, marginBottom: 10 }}>Payment Mapping</div>
      <p style={{ margin: "0 0 12px" }}>
        Maps POS payment methods to General Ledger (GL) accounts used in the accounting system.
        This allows each payment type (Cash, Visa, MasterCard, Room Charge, Gift Card, etc.) to
        be posted to the correct accounting account during Journal Entry export.
      </p>
      <p style={{ margin: "0 0 10px" }}>
        Some accounting integrations, such as QuickBooks, also support additional mapping fields
        including:
      </p>
      <ul style={{ margin: "0 0 12px 20px", padding: 0 }}>
        <li>Class</li>
        <li>Location</li>
        <li>Department</li>
        <li>Vendor / Customer</li>
      </ul>
      <p style={{ margin: 0 }}>
        These fields provide more detailed financial segmentation and reporting within the
        accounting platform.

        If multiple payment methods are mapped to the same GL Account and Description, 
        their amounts will be grouped and exported as a single summarized Journal Entry line.
      </p>
    </>
  );

  const categoryMappingDescription = (
    <>
      <div style={{ fontWeight: 700, marginBottom: 10 }}>Category Mapping</div>
      <p style={{ margin: "0 0 12px" }}>
        Maps POS sales categories to General Ledger (GL) accounts used in the accounting system.
        This ensures that revenue from each category (Food, Beverage, Retail, Services, etc.) is
        posted to the correct accounting account during Journal Entry export.
      </p>
      <p style={{ margin: "0 0 10px" }}>
        Some accounting integrations, such as QuickBooks, also support additional mapping fields
        including:
      </p>
      <ul style={{ margin: "0 0 12px 20px", padding: 0 }}>
        <li>Class</li>
        <li>Location</li>
        <li>Department</li>
        <li>Vendor / Customer</li>
      </ul>
      <p style={{ margin: 0 }}>
        These fields allow more detailed financial tracking, reporting, and segmentation within
        the accounting platform.

        If multiple categories are mapped to the same GL Account and Description, 
        their amounts will be grouped and exported as a single summarized Journal Entry line.
      </p>
    </>
  );

  const categoryMultiGlDescription = (
    <>
      <p style={{ margin: "0 0 12px" }}>
        Allows a single POS category to be split across multiple General Ledger (GL) accounts
        during Journal Entry export.
      </p>
      <p style={{ margin: "0 0 12px" }}>
        Each category can be divided into up to 7 different mappings, using percentage-based
        allocation. The total allocation percentage across all mappings must equal 100%.
      </p>
      <p style={{ margin: "0 0 8px" }}>For example:</p>
      <div style={{ marginBottom: 12 }}>
        <div>Total category amount: 300</div>
        <div style={{ marginTop: 8, fontWeight: 600 }}>Split configuration:</div>
        <div>GL Account A -> 50%</div>
        <div>GL Account B -> 20%</div>
        <div>GL Account C -> 20%</div>
        <div>GL Account D -> 10%</div>
      </div>
      <div style={{ marginBottom: 12 }}>
        <div style={{ fontWeight: 600 }}>The exported Journal Entry amounts would be:</div>
        <div>GL Account A -> 150.00</div>
        <div>GL Account B -> 60.00</div>
        <div>GL Account C -> 60.00</div>
        <div>GL Account D -> 30.00</div>
      </div>
      <p style={{ margin: 0 }}>
        If multiple category mappings use the same GL Account and Description, their amounts will
        be grouped and exported as a single summarized Journal Entry line.
      </p>
    </>
  );

  const categoryRoundDescription = (
    <>
      <p style={{ margin: "0 0 12px" }}>
        Displays the total quantity of items sold for mapped categories. This feature is intended
        for quantity-based category mapping, where the exported value represents the total number
        of items sold rather than the sales amount.
      </p>
      <p style={{ margin: 0 }}>
        Only categories that are mapped in this section will be included and displayed in the
        report.
      </p>
      <p style={{ margin: "12px 0" }}>
        The quantity value will be posted on the Debit side. If you also want a Credit entry
        (which will display the total summed quantity of all mapped categories), the corresponding
        option must be enabled and a GL Account must be mapped.
      </p>
      <div
        style={{
          border: "1px solid #cbd5e1",
          borderRadius: 6,
          marginBottom: 12,
          background: "#fff",
          overflow: "hidden",
        }}
      >
        <img
          src={roundingS2Image}
          alt="Show sum of rounds as credit settings"
          style={{
            display: "block",
            width: "100%",
            height: "auto",
          }}
        />
      </div>
      <div
        style={{
          display: "none",
          border: "1px solid #cbd5e1",
          borderRadius: 6,
          padding: 8,
          marginBottom: 12,
          transform: "scale(0.82)",
          transformOrigin: "left top",
          width: "122%",
          background: "#fff",
          overflow: "hidden",
        }}
      >
        <div style={{ display: "grid", gap: 3, fontSize: 11, color: "#0f172a" }}>
          <div style={{ border: "1px solid #d7d7d7", borderRadius: 4, padding: "6px 10px", display: "flex", alignItems: "center", gap: 14 }}>
            <strong style={{ minWidth: 120 }}>Discount</strong>
            <span>○ Gross Sales by Categories (before discount)</span>
            <span>○ Gross Sales by Categories (2) (before discount / credit summary)</span>
            <span>◉ By type</span>
            <span>○ By category</span>
            <span>○ Summary</span>
            <span>○ off</span>
          </div>
          <div style={{ border: "1px solid #d7d7d7", borderRadius: 4, padding: "8px 10px" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <strong style={{ minWidth: 120 }}>Tax Option</strong>
            </div>
            <div style={{ marginTop: 6 }}>
              <span>◉ default</span>
              <span style={{ marginLeft: 12 }}>○ NO_TAX</span>
              <span style={{ marginLeft: 12 }}>○ TAX-CLASS-TAX1-TAX2</span>
              <span style={{ marginLeft: 12 }}>○ TAX_CLASS_A_2_SEPARATED</span>
              <span style={{ marginLeft: 12 }}>○ Tax Class Allocation</span>
            </div>
          </div>
          <div style={{ border: "1px solid #d7d7d7", borderRadius: 4, padding: "6px 10px", display: "flex", alignItems: "center", gap: 14 }}>
            <strong style={{ minWidth: 120 }}>Show COGS</strong>
            <span>◉ on</span>
            <span>○ off</span>
          </div>
          <div style={{ border: "1px solid #d7d7d7", borderRadius: 4, padding: "8px 10px" }}>
            <strong>Calculation field</strong>
            <div style={{ marginTop: 6 }}>
              <span>◉ default</span>
              <span style={{ marginLeft: 12 }}>○ calcSubtotal</span>
              <span style={{ marginLeft: 12 }}>○ calcSubtotal - calcLineDiscount</span>
              <span style={{ marginLeft: 12 }}>○ calctotal</span>
            </div>
          </div>
          {[
            ["Retail (R) Credit Card Fees", "○ Off", "◉ Show as Debit / Credit", "○ Show as Deducted from Payment | Debit (summary)"],
            ["Retail (R) Surcharge", "○ Off", "◉ On"],
            ["Payment without description (One line)", "○ on", "◉ off"],
            ["Category without description (One line)", "○ on", "◉ off"],
          ].map(([label, ...options]) => (
            <div
              key={label}
              style={{ border: "1px solid #d7d7d7", borderRadius: 4, padding: "6px 10px", display: "flex", alignItems: "center", gap: 14 }}
            >
              <strong style={{ minWidth: 210 }}>{label}</strong>
              {options.map((option) => (
                <span key={option}>{option}</span>
              ))}
            </div>
          ))}
          <div
            style={{
              border: "2px solid #ef0000",
              padding: "8px 10px",
              display: "flex",
              alignItems: "center",
              gap: 14,
            }}
          >
            <strong>Show sum of rounds as credit</strong>
            <span>◉ on</span>
            <span>○ off</span>
            <span
              style={{
                border: "1px solid #b7c2d0",
                borderRadius: 2,
                padding: "6px 12px",
                minWidth: 92,
                background: "#fff",
              }}
            >
              8001
            </span>
            <span
              style={{
                border: "1px solid #2563eb",
                borderRadius: 2,
                padding: "6px 12px",
                minWidth: 150,
                background: "#fff",
              }}
            >
              Rounds Total
            </span>
          </div>
          <div style={{ border: "1px solid #d7d7d7", borderRadius: 4, padding: "6px 10px", display: "flex", alignItems: "center", gap: 14 }}>
            <strong style={{ minWidth: 120 }}>Cash Over/Short</strong>
            <span>◉ on</span>
            <span>○ off</span>
          </div>
          <div style={{ border: "1px solid #d7d7d7", borderRadius: 4, padding: "6px 10px", display: "flex", alignItems: "center", gap: 14 }}>
            <strong style={{ minWidth: 120 }}>Deferred Revenue</strong>
            <span>○ on</span>
            <span>◉ off</span>
          </div>
          <div style={{ border: "1px solid #d7d7d7", borderRadius: 4, padding: "8px 10px", display: "flex", alignItems: "center", gap: 18 }}>
            <strong style={{ minWidth: 120 }}>Time Zone</strong>
            <span style={{ border: "1px solid #c8c8c8", borderRadius: 3, padding: "7px 12px", minWidth: 360, background: "#fff" }}>
              US Eastern Standard Time (UTC-04:00)
            </span>
          </div>
          <div style={{ border: "1px solid #d7d7d7", borderRadius: 4, padding: "8px 10px", display: "flex", alignItems: "center", gap: 14 }}>
            <strong style={{ minWidth: 120 }}>Email List</strong>
            <span style={{ border: "1px solid #c8c8c8", borderRadius: 3, padding: "7px 12px", minWidth: 560, background: "#fff" }}>
              damir@beesql.com, tom@beesql.com, tom@beesql.com
            </span>
            <strong>Time</strong>
            <span style={{ border: "1px solid #c8c8c8", borderRadius: 3, padding: "7px 12px", background: "#fff" }}>13:00</span>
          </div>
        </div>
      </div>
      <div
        style={{
          border: "1px solid #cbd5e1",
          borderRadius: 6,
          overflow: "hidden",
          fontSize: 11,
          background: "#eaf2fc",
        }}
      >
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1.1fr 1.4fr 1.5fr 0.65fr 0.65fr 1.4fr 1.1fr 0.8fr",
            fontWeight: 700,
            background: "#dbeafe",
          }}
        >
          {["transaction_date", "account_id", "account_description", "debit", "credit", "posting_comment", "xoption", "Totals"].map((label) => (
            <div key={label} style={{ border: "1px solid #bcd0e8", padding: 4 }}>
              {label}
            </div>
          ))}
        </div>
        {[
          ["2026-05-07", "R14", "", "1.00", "0.00", "", "ROUNDS", "1.00"],
          ["2026-05-07", "R15", "", "10.00", "0.00", "", "ROUNDS", "10.00"],
          ["2026-05-07", "", "Rounds Total", "0.00", "11.00", "", "Rounds Total", "-11.00"],
        ].map((row, index) => (
          <div
            key={index}
            style={{
              display: "grid",
              gridTemplateColumns: "1.1fr 1.4fr 1.5fr 0.65fr 0.65fr 1.4fr 1.1fr 0.8fr",
              borderLeft: "2px solid #ef4444",
              borderRight: "2px solid #ef4444",
              borderTop: index === 0 ? "2px solid #ef4444" : 0,
              borderBottom: index === 2 ? "2px solid #ef4444" : 0,
            }}
          >
            {row.map((cell, cellIndex) => (
              <div
                key={`${index}-${cellIndex}`}
                style={{ border: "1px solid #bcd0e8", padding: 4, textAlign: cellIndex >= 3 ? "right" : "left", fontWeight: 700 }}
              >
                {cell}
              </div>
            ))}
          </div>
        ))}
      </div>
    </>
  );

  const surchargeDescription = (
    <>
      <p style={{ margin: "0 0 16px" }}>
        Example receipt and the resulting journal entry options for a surcharge.
      </p>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "flex-start",
          gap: 16,
        }}
      >
        <div style={{ flex: "0 1 320px", minWidth: 240 }}>
          <div style={{ marginBottom: 6, fontWeight: 600 }}>Receipt</div>
          <img
            src={receiptImage}
            alt="Receipt showing a surcharge amount"
            style={{ display: "block", width: "100%", height: "auto", border: "1px solid #e2e8f0" }}
          />
        </div>
        <div style={{ flex: "1 1 520px", minWidth: 280, maxWidth: 700 }}>
          <div style={{ marginBottom: 6, fontWeight: 600 }}>Surcharge Posting Examples</div>
          <img
            src={surchargeExampleImage}
            alt="Journal entry examples for surcharge display options"
            style={{ display: "block", width: "100%", height: "auto", border: "1px solid #e2e8f0" }}
          />
        </div>
      </div>
    </>
  );

  const shopTabContainer = (
    <TabContainer className="modern-tab-container">
      {renderTab(0, "Payments", (_) => {
        if (ui.table !== 0) dispatch(setCurrentTable(0));

        dispatch(databaseActions.setShopPayments([]));

        if (database.currentCompany.type === "RETAILX") {
          dispatch(
            databaseActions.getShopPaymentsX(
              database.currentCompany.id,
              userState.user.user_id,
              database.currentShop.shop_id
            )
          );
        } else {
          dispatch(
            databaseActions.getShopPayments(
              database.currentCompany.id,
              userState.user.user_id,
              database.currentShop.shop_id
            )
          );
        }
      }, {
        title: "Payments",
        description: paymentMappingDescription,
        tooltip: "Maps POS payment methods to General Ledger (GL) accounts.",
      })}

      {!acombagoIntegration && renderTab(11, <>Payments<br />deferred</>, (_) => {
        if (ui.table !== 11) dispatch(setCurrentTable(11));

        dispatch(databaseActions.setShopPaymentsDeferred([]));
        dispatch(
          databaseActions.getShopPaymentsDeferred(
            database.currentCompany.id,
            userState.user.user_id,
            database.currentShop.shop_id
          )
        );
      }, {
        title: "Payments deferred",
        description: "Maps deferred payment entries to accounting accounts.",
      }, {
        title: "Payments",
        description: "Maps restaurant payment types to accounting accounts.",
      })}

      {renderTab(1, "Categories", (_) => {
        if (ui.table !== 1) dispatch(setCurrentTable(1));

        dispatch(databaseActions.setShopCategories([]));

        if (database.currentCompany.type === "RETAILX") {
          dispatch(
            databaseActions.getShopCategoriesX(
              database.currentCompany.id,
              userState.user.user_id,
              database.currentShop.shop_id
            )
          );
        } else {
          dispatch(
            databaseActions.getShopCategories(
              database.currentCompany.id,
              userState.user.user_id,
              database.currentShop.shop_id
            )
          );
        }
      }, {
        title: "Categories",
        description: categoryMappingDescription,
        tooltip: "Maps POS sales categories to General Ledger (GL) accounts.",
      })}

      {!acombagoIntegration && renderTab(12, <>Categories<br />Deferred</>, (_) => {
        if (ui.table !== 12) dispatch(setCurrentTable(12));

        dispatch(databaseActions.setShopCategoriesDeferred([]));
        dispatch(
          databaseActions.getShopCategoriesDeferred(
            database.currentCompany.id,
            userState.user.user_id,
            database.currentShop.shop_id
          )
        );
      }, {
        title: "Categories Deferred",
        description: "Maps deferred category values to accounting accounts.",
      })}

      {renderTab(2, <>Categories<br />Multi GL</>, (_) => {
        if (ui.table !== 2) dispatch(setCurrentTable(2));

        dispatch(databaseActions.setShopCategoriesMulti([]));
        dispatch(
          databaseActions.getShopCategoriesMulti(
            database.currentCompany.id,
            userState.user.user_id,
            database.currentShop.shop_id
          )
        );
      }, {
        title: "Categories Multi GL",
        description: categoryMultiGlDescription,
        tooltip: "Allows a single POS category to be split across multiple GL accounts.",
      })}

      {renderTab(
        3,
        <>Categories<br />Round</>,
        (_) => {
          if (ui.table !== 3) dispatch(setCurrentTable(3));

          dispatch(databaseActions.setShopCategoriesRound([]));

          if (database.currentCompany.type === "RETAILX") {
            dispatch(
              databaseActions.getShopCategoriesRoundX(
                database.currentCompany.id,
                userState.user.user_id,
                database.currentShop.shop_id
              )
            );
          } else {
            dispatch(
              databaseActions.getShopCategoriesRound(
                database.currentCompany.id,
                userState.user.user_id,
                database.currentShop.shop_id
              )
            );
          }
        },
        {
          title: "Categories Round",
          description: categoryRoundDescription,
        }
      )}

      {renderTab(4, "Other", (_) => {
        if (ui.table !== 4) dispatch(setCurrentTable(4));

        dispatch(databaseActions.setShopCategoriesOther([]));

        if (database.currentCompany.type === "RETAILX") {
          dispatch(
            databaseActions.getShopCategoriesOtherX(
              database.currentCompany.id,
              userState.user.user_id,
              database.currentShop.shop_id
            )
          );
        } else {
          dispatch(
            databaseActions.getShopCategoriesOther(
              database.currentCompany.id,
              userState.user.user_id,
              database.currentShop.shop_id
            )
          );
        }
      }, {
        title: "Other",
        description: "Maps over/short amounts, tips, and other adjustment categories.",
      })}

      {renderTab(5, <>Items without <br />category</>, (_) => {
        if (ui.table !== 5) dispatch(setCurrentTable(5));

        dispatch(databaseActions.setShopCategoriesLess([]));

        if (database.currentCompany.type === "RETAILX") {
          dispatch(
            databaseActions.getShopCategoriesLessX(
              database.currentCompany.id,
              userState.user.user_id,
              database.currentShop.shop_id
            )
          );
        } else {
          dispatch(
            databaseActions.getShopCategoriesLess(
              database.currentCompany.id,
              userState.user.user_id,
              database.currentShop.shop_id
            )
          );
        }
      }, {
        title: "Items without category",
        description: "Shows items that do not have a POS category assigned.",
      })}

      {renderTab(7, "Taxes", (_) => {
        if (ui.table !== 7) dispatch(setCurrentTable(7));

        if (database.currentCompany.type === "RETAILX") {
          dispatch(databaseActions.setShopTaxesX([]));
          dispatch(
            databaseActions.getShopTaxesX(
              database.currentCompany.id,
              userState.user.user_id,
              database.currentShop.shop_id
            )
          );
        } else {
          dispatch(databaseActions.setShopTaxes([]));
          dispatch(
            databaseActions.getShopTaxes(
              database.currentCompany.id,
              userState.user.user_id,
              database.currentShop.shop_id
            )
          );
        }
      }, {
        title: "Taxes",
        description: "Maps POS tax records to accounting accounts.",
      })}

      {renderTab(6, "Report Retail", (_) => {
        if (ui.table !== 6) dispatch(setCurrentTable(6));
        dispatch(databaseActions.setShopReport([]));
      }, {
        title: "Report Retail",
        description: "Opens retail reporting and export tools.",
      })}

      {renderTab(
        8,
        database.currentCompany.type === "RETAILX" ? "Imports (X)" : "Imports (R)",
        (_) => {
          if (ui.table !== 8) dispatch(setCurrentTable(8));

          dispatch(databaseActions.setShopImport([]));
          dispatch(
            databaseActions.getShopImport(
              database.currentCompany.id,
              userState.user.user_id,
              database.currentShop.shop_id
            )
          );
        },
        {
          title: database.currentCompany.type === "RETAILX" ? "Imports (X)" : "Imports (R)",
          description:
            "Imports are reserved for direct accounting integrations such as Sage, QuickBooks, and Xero, where Journal Entries are automatically generated and exported directly into the accounting system.",
        }
      )}
      {showImportsPO && renderTab(13, "Imports (PO)", () => {
        if (ui.table !== 13) dispatch(setCurrentTable(13));
        dispatch(setShopImportPO([]));
        dispatch(getShopImportPO(
          database.currentCompany.id,
          userState.user.user_id,
          database.currentShop.shop_id
        ));
      }, {
        title: "Imports (PO)",
        description: "Imports for the Acomba SDK integration.",
      })}
    </TabContainer>
  );

  const areaTabContainer = (
    <TabContainer className="modern-tab-container">
      {renderTab(0, "Payments", (_) => {
        if (ui.table !== 0) dispatch(setCurrentTable(0));
        dispatch(databaseActions.setAreaPayments([]));

        if (database.currentCompany.type === "RESTOK") {
          dispatch(
            databaseActions.getAreaPaymentsK(
              userState.user.user_id,
              database.currentCompany.direct
                ? database.currentShop.company_id
                : database.currentCompany.id,
              database.currentCompany.direct ? 0 : database.currentShop.area_id
            )
          );
        } else {
          dispatch(
            databaseActions.getAreaPayments(
              userState.user.user_id,
              database.currentCompany.direct
                ? database.currentShop.company_id
                : database.currentCompany.id,
              database.currentCompany.direct ? 0 : database.currentShop.area_id
            )
          );
        }
      })}

      {renderTab(1, "Categories", (_) => {
        if (ui.table !== 1) dispatch(setCurrentTable(1));

        if (database.currentCompany.type === "RESTOK") {
          dispatch(databaseActions.setAreaCategoriesK([]));
          dispatch(
            databaseActions.getAreaCategoriesK(
              userState.user.user_id,
              database.currentCompany.direct
                ? database.currentShop.company_id
                : database.currentCompany.id,
              database.currentCompany.direct ? 0 : database.currentShop.area_id
            )
          );
        } else {
          dispatch(databaseActions.setAreaCategories([]));
          dispatch(
            databaseActions.getAreaCategories(
              userState.user.user_id,
              database.currentCompany.direct
                ? database.currentShop.company_id
                : database.currentCompany.id,
              database.currentCompany.direct ? 0 : database.currentShop.area_id
            )
          );
        }
      }, {
        title: "Categories",
        description: "Maps restaurant categories to accounting accounts and related fields.",
      })}

      {renderTab(4, "Other", (_) => {
        if (ui.table !== 4) dispatch(setCurrentTable(4));

        if (database.currentCompany.type === "RESTOK") {
          dispatch(databaseActions.setAreaCategoriesOtherK([]));
          dispatch(
            databaseActions.getAreaCategoriesOtherK(
              userState.user.user_id,
              database.currentCompany.direct
                ? database.currentShop.company_id
                : database.currentCompany.id,
              database.currentCompany.direct ? 0 : database.currentShop.area_id
            )
          );
        } else {
          dispatch(databaseActions.setAreaCategoriesOther([]));
          dispatch(
            databaseActions.getAreaCategoriesOther(
              userState.user.user_id,
              database.currentCompany.direct
                ? database.currentShop.company_id
                : database.currentCompany.id,
              database.currentCompany.direct ? 0 : database.currentShop.area_id
            )
          );
        }
      }, {
        title: "Other",
        description: "Maps restaurant over/short, tips, and other adjustment categories.",
      })}

      {renderTab(7, "Taxes (Resto)", (_) => {
        if (ui.table !== 7) dispatch(setCurrentTable(7));

        if (database.currentCompany.type === "RESTOK") {
          dispatch(databaseActions.setAreaTaxesK([]));
          dispatch(
            databaseActions.getAreaTaxesK(
              userState.user.user_id,
              database.currentCompany.direct
                ? database.currentShop.company_id
                : database.currentCompany.id,
              database.currentCompany.direct ? 0 : database.currentShop.area_id
            )
          );
        } else {
          dispatch(databaseActions.setAreaTaxes([]));
          dispatch(
            databaseActions.getAreaTaxes(
              userState.user.user_id,
              database.currentCompany.direct
                ? database.currentShop.company_id
                : database.currentCompany.id,
              database.currentCompany.direct ? 0 : database.currentShop.area_id
            )
          );
        }
      }, {
        title: "Taxes (Resto)",
        description: "Maps restaurant taxes to accounting accounts.",
      })}

      {renderTab(
        10,
        database.currentCompany.type === "RESTOK"
          ? "Report Restaurant (K)"
          : database.currentCompany.type === "RESTO"
          ? "Report Restaurant (L)"
          : "Report Restaurant",
        (_) => {
          if (ui.table !== 10) dispatch(setCurrentTable(10));
          dispatch(databaseActions.setShopReport([]));
        },
        {
          title:
            database.currentCompany.type === "RESTOK"
              ? "Report Restaurant (K)"
              : database.currentCompany.type === "RESTO"
              ? "Report Restaurant (L)"
              : "Report Restaurant",
          description:
            database.currentCompany.type === "RESTOK"
              ? restaurantKReportDescription
              : "Opens restaurant reporting and export tools.",
          maxWidth: database.currentCompany.type === "RESTOK" ? 960 : undefined,
        }
      )}

      {renderTab(
        9,
        database.currentCompany.type === "RESTOK" ? "Imports (K)" : "Imports (L)",
        (_) => {
          if (ui.table !== 9) dispatch(setCurrentTable(9));
          dispatch(databaseActions.setShopImport([]));
          dispatch(
            databaseActions.getShopImport(
              database.currentCompany.id,
              userState.user.user_id,
              database.currentShop.area_id
            )
          );
        },
        {
          title: database.currentCompany.type === "RESTOK" ? "Imports (K)" : "Imports (L)",
          description: "Imports restaurant mapping data into the reporting tool.",
        }
      )}
    </TabContainer>
  );

  const settingsButtonLabel =
    database.currentCompany.type === "RETAIL"
      ? "⚙️ Settings (R)"
      : database.currentCompany.type === "RESTO"
      ? "⚙️ Settings (L)"
      : database.currentCompany.type === "RESTOK"
      ? "⚙️ Settings (K)"
      : null;

  return (
    <Card
      className={`categories-bar ${ui.theme === "flame" ? "" : "categories-bar-dark"}`}
      style={{
        display: "flex",
        alignItems: "center",
        gap: 12,
        padding: "10px 12px",
        paddingRight: 12,
        borderRadius: 18,
      }}
    >
      {database.currentCompany.type === "RETAIL" ||
      database.currentCompany.type === "RETAILX"
        ? shopTabContainer
        : areaTabContainer}

      <div
        className="categories-bar-actions"
        style={{
          display: "flex",
          alignItems: "center",
          gap: 8,
          flexWrap: "nowrap",
          marginLeft: "auto",
          whiteSpace: "nowrap",
        }}
      >
        {(database.currentCompany.type === "RETAIL" ||
          database.currentCompany.type === "RETAILX" ||
          database.currentCompany.type === "RESTOK") &&
          (ui.table === 1 || ui.table === 12) && (
            <Button
              size="small"
              fill="true"
              onClick={() => dispatch(setShowHiddenFields(!ui.showHiddenFields))}
              title={ui.showHiddenFields ? "Hide hidden fields" : "Show hidden fields"}
              aria-label={ui.showHiddenFields ? "Hide hidden fields" : "Show hidden fields"}
              style={{
                flexShrink: 0,
                width: 36,
                minWidth: 36,
                paddingLeft: 0,
                paddingRight: 0,
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {ui.showHiddenFields ? <FaCompressAlt /> : <FaExpandAlt />}
            </Button>
          )}

        <Button
          size="small"
          onClick={() => setShowTableSearch((current) => !current)}
          title="Search table"
          aria-label="Search table"
          style={{
            flexShrink: 0,
            width: 36,
            minWidth: 36,
            paddingLeft: 0,
            paddingRight: 0,
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <FaSearch />
        </Button>

        {(showTableSearch || ui.search) && (
          <div style={{ flexShrink: 0 }}>
            <Input
              value={ui.search}
              onChange={(valueOrEvent) => {
                const value = getValue(valueOrEvent, "");
                dispatch(setSearch(value));
              }}
              type="text"
              size="small"
              placeholder="Search"
              width="125px"
            />
          </div>
        )}

        {settingsButtonLabel && (
          <Button
            size="small"
            onClick={() => {
              setSettingsTab("general");
              setShowSettings(true);
            }}
            title="Open Settings"
            aria-label={settingsButtonLabel}
            style={{
              flexShrink: 0,
              width: 36,
              minWidth: 36,
              paddingLeft: 0,
              paddingRight: 0,
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <FaCog />
          </Button>
        )}
      </div>

      {showSettings && database.currentCompany.type === "RETAIL" && (
        <Modal
          open={showSettings}
          isOpen={showSettings}
          onClose={closeSettingsModal}
          title="Settings"
          ariaHideApp={false}
        >
          <div
            style={{
              width: "min(96vw, 1410px)",
              maxHeight: "calc(100vh - 96px)",
              maxWidth: 1410,
              minWidth: 0,
              padding: 16,
              display: "flex",
              flexDirection: "column",
              fontSize: 12,
              overflow: "hidden",
            }}
          >
            <div style={{ display: "flex", justifyContent: "flex-start", flexShrink: 0 }}>
              {renderSettingsAgenda(true)}
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
                gap: 14,
                overflow: "auto",
                flex: 1,
                minHeight: 0,
                paddingRight: 6,
              }}
            >
              <div style={{ border: "1px solid #bfdbfe", borderRadius: 8, overflow: "hidden", background: "#f8fbff", display: "flex", flexDirection: "column", minHeight: 0, maxHeight: "min(42vh, 430px)" }}>
                <div style={{ display: "flex", alignItems: "center", gap: 12, padding: "14px 16px", borderBottom: "1px solid #bfdbfe", background: "#eff6ff", flexShrink: 0 }}>
                  <span style={{ width: 34, height: 34, borderRadius: "50%", background: "#2563eb", color: "#fff", display: "inline-flex", alignItems: "center", justifyContent: "center", fontWeight: 800 }}>1</span>
                  <div>
                    <div style={{ fontSize: 15, fontWeight: 800, color: "#1e3a8a" }}>{t("Visual & Display")}</div>
                    <div style={{ fontSize: 10, color: "#1d4ed8" }}>{t("Report display options")}</div>
                  </div>
                </div>
                <div style={{ display: "grid", gap: 10, padding: 12, overflowY: "auto", minHeight: 0, flex: 1, alignContent: "start" }}>
                  <div style={{ border: "1px solid #e5e7eb", borderRadius: 6, padding: "12px 44px 12px 12px", background: "#fff", position: "relative" }}>
                    <div style={{ position: "absolute", top: 8, right: 8 }}>{renderSettingsGroupBadges(["A"])}</div>
                    <div style={{ fontSize: 12, fontWeight: 700, marginBottom: 8, display: "flex", alignItems: "center", gap: 6 }}>
                      Discount
                      {renderSettingsInfo("Discount", discountDescription, 1300)}
                    </div>
                    <div style={{ display: "flex", flexWrap: "wrap", gap: "8px 14px" }}>
                      <label><input type="radio" name="discount_settings" value="gross_sales" checked={settings.discount_settings === "gross_sales"} onChange={updateSetting("discount_settings", "off")} />{" "}Gross Sales by Categories (before discount)</label>
                      <label><input type="radio" name="discount_settings" value="gross_sales2" checked={settings.discount_settings === "gross_sales2"} onChange={updateSetting("discount_settings", "off")} />{" "}Gross Sales by Categories (2) (before discount / credit summary)</label>
                      <label><input type="radio" name="discount_settings" value="type" checked={settings.discount_settings === "type"} onChange={updateSetting("discount_settings", "off")} />{" "}By type</label>
                      <label><input type="radio" name="discount_settings" value="category" checked={settings.discount_settings === "category"} onChange={updateSetting("discount_settings", "off")} />{" "}By category</label>
                      <label><input type="radio" name="discount_settings" value="summary" checked={settings.discount_settings === "summary"} onChange={updateSetting("discount_settings", "off")} />{" "}Summary</label>
                      <label><input type="radio" name="discount_settings" value="off" checked={settings.discount_settings === "off"} onChange={updateSetting("discount_settings", "off")} />{" "}off</label>
                    </div>
                  </div>
                  <div style={{ border: "1px solid #e5e7eb", borderRadius: 6, padding: "12px 86px 12px 12px", background: "#fff", display: "flex", alignItems: "center", gap: 14, flexWrap: "wrap", position: "relative" }}>
                    <div style={{ position: "absolute", top: 8, right: 8 }}>{renderSettingsGroupBadges(["A", "B", "C"])}</div>
                    <div style={{ fontSize: 12, fontWeight: 700, display: "flex", alignItems: "center", gap: 6, minWidth: 110 }}>
                      Show COGS
                      {renderSettingsInfo("Show COGS", cogsDescription, 900)}
                    </div>
                    <label><input type="radio" name="cogs_enabled" value="on" checked={settings.cogs_enabled === "on"} onChange={updateSetting("cogs_enabled", "off")} />{" "}on</label>
                    <label><input type="radio" name="cogs_enabled" value="off" checked={settings.cogs_enabled === "off"} onChange={updateSetting("cogs_enabled", "off")} />{" "}off</label>
                  </div>
                  <div style={{ border: "1px solid #e5e7eb", borderRadius: 6, padding: "12px 44px 12px 12px", background: "#fff", position: "relative" }}>
                    <div style={{ position: "absolute", top: 8, right: 8 }}>{renderSettingsGroupBadges(["B"])}</div>
                    <div style={{ fontSize: 12, fontWeight: 700, marginBottom: 8, display: "flex", alignItems: "center", gap: 6 }}>
                      Payment without description (One line)
                      {renderSettingsInfo("Payment without description", paymentWithoutDescriptionDescription, 900)}
                    </div>
                    <div style={{ display: "flex", flexWrap: "nowrap", gap: "8px 14px", whiteSpace: "nowrap" }}>
                      <label style={{ whiteSpace: "nowrap" }}><input type="radio" name="NO_DESCRIPTION_PAYMENT_R" value="on" checked={settings.NO_DESCRIPTION_PAYMENT_R === "on"} onChange={updateSetting("NO_DESCRIPTION_PAYMENT_R", "off")} />{" "}on</label>
                      <label style={{ whiteSpace: "nowrap" }}><input type="radio" name="NO_DESCRIPTION_PAYMENT_R" value="off" checked={settings.NO_DESCRIPTION_PAYMENT_R === "off"} onChange={updateSetting("NO_DESCRIPTION_PAYMENT_R", "off")} />{" "}off</label>
                    </div>
                  </div>
                  <div style={{ border: "1px solid #e5e7eb", borderRadius: 6, padding: "12px 44px 12px 12px", background: "#fff", position: "relative" }}>
                    <div style={{ position: "absolute", top: 8, right: 8 }}>{renderSettingsGroupBadges(["B"])}</div>
                    <div style={{ fontSize: 12, fontWeight: 700, marginBottom: 8, display: "flex", alignItems: "center", gap: 6 }}>
                      Category without description (One line)
                      {renderSettingsInfo("Category without description", categoryWithoutDescriptionDescription, 900)}
                    </div>
                    <div style={{ display: "flex", flexWrap: "nowrap", gap: "8px 14px", whiteSpace: "nowrap" }}>
                      <label style={{ whiteSpace: "nowrap" }}><input type="radio" name="NO_DESCRIPTION_CATEGORY_R" value="on" checked={settings.NO_DESCRIPTION_CATEGORY_R === "on"} onChange={updateSetting("NO_DESCRIPTION_CATEGORY_R", "off")} />{" "}on</label>
                      <label style={{ whiteSpace: "nowrap" }}><input type="radio" name="NO_DESCRIPTION_CATEGORY_R" value="off" checked={settings.NO_DESCRIPTION_CATEGORY_R === "off"} onChange={updateSetting("NO_DESCRIPTION_CATEGORY_R", "off")} />{" "}off</label>
                    </div>
                  </div>
                </div>
              </div>

              <div style={{ border: "1px solid #bfdbfe", borderRadius: 8, overflow: "hidden", background: "#f8fbff", display: "flex", flexDirection: "column", minHeight: 0, maxHeight: "min(42vh, 430px)" }}>
                <div style={{ display: "flex", alignItems: "center", gap: 12, padding: "14px 16px", borderBottom: "1px solid #bfdbfe", background: "#eff6ff", flexShrink: 0 }}>
                  <span style={{ width: 34, height: 34, borderRadius: "50%", background: "#2563eb", color: "#fff", display: "inline-flex", alignItems: "center", justifyContent: "center", fontWeight: 800 }}>2</span>
                  <div>
                    <div style={{ fontSize: 15, fontWeight: 800, color: "#1e3a8a" }}>{t("Sales & Discounts")}</div>
                    <div style={{ fontSize: 10, color: "#1d4ed8" }}>{t("Sales calculation options")}</div>
                  </div>
                </div>
                <div style={{ display: "grid", gap: 10, padding: 12, overflowY: "auto", minHeight: 0, flex: 1, alignContent: "start" }}>
                  <div style={{ border: "1px solid #e5e7eb", borderRadius: 6, padding: 12, background: "#fff" }}>
                    <div style={{ fontSize: 12, fontWeight: 700, marginBottom: 8 }}>Calculation field</div>
                    <div style={{ display: "grid", gap: 8 }}>
                      {[
                        { value: "default", label: "default" },
                        { value: "calcSubtotal", label: "calcSubtotal" },
                        { value: "calcSubtotal - calcLineDiscount", label: "calcSubtotal - calcLineDiscount" },
                        { value: "calctotal", label: "calctotal" },
                      ].map((opt) => (
                        <label key={opt.value}><input type="radio" name="calculation_formula" value={opt.value} checked={settings.calculation_formula === opt.value} onChange={updateSetting("calculation_formula", "default")} />{" "}{opt.label}</label>
                      ))}
                    </div>
                  </div>
                  <div style={{ border: "1px solid #e5e7eb", borderRadius: 6, padding: 12, background: "#fff", display: "grid", gap: 8 }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 14, flexWrap: "wrap" }}>
                      <div style={{ fontSize: 12, fontWeight: 700, display: "flex", alignItems: "center", gap: 6, minWidth: 210 }}>
                        Show sum of rounds as credit
                        {renderSettingsInfo("Show sum of rounds as credit", roundsCreditDescription, 900)}
                      </div>
                      <label><input type="radio" name="show_sum_of_rounds_as_credit" value="on" checked={settings.show_sum_of_rounds_as_credit === "on"} onChange={updateSetting("show_sum_of_rounds_as_credit", "off")} />{" "}on</label>
                      <label><input type="radio" name="show_sum_of_rounds_as_credit" value="off" checked={settings.show_sum_of_rounds_as_credit === "off"} onChange={updateSetting("show_sum_of_rounds_as_credit", "off")} />{" "}off</label>
                    </div>
                    <div style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap", paddingLeft: 0 }}>
                      <Input value={settings.show_sum_of_rounds_as_credit_gl_id || ""} onChange={updateSetting("show_sum_of_rounds_as_credit_gl_id", "")} type="text" size="small" placeholder="GL Id" width="120px" />
                      <Input value={settings.show_sum_of_rounds_as_credit_gl_description || ""} onChange={updateSetting("show_sum_of_rounds_as_credit_gl_description", "")} type="text" size="small" placeholder="GL Description" width="180px" />
                    </div>
                  </div>
                </div>
              </div>

              <div style={{ border: "1px solid #bfdbfe", borderRadius: 8, overflow: "hidden", background: "#f8fbff", display: "flex", flexDirection: "column", minHeight: 0, maxHeight: "min(42vh, 430px)" }}>
                <div style={{ display: "flex", alignItems: "center", gap: 12, padding: "14px 16px", borderBottom: "1px solid #bfdbfe", background: "#eff6ff", flexShrink: 0 }}>
                  <span style={{ width: 34, height: 34, borderRadius: "50%", background: "#2563eb", color: "#fff", display: "inline-flex", alignItems: "center", justifyContent: "center", fontWeight: 800 }}>3</span>
                  <div>
                    <div style={{ fontSize: 15, fontWeight: 800, color: "#1e3a8a" }}>{t("Taxes")}</div>
                    <div style={{ fontSize: 10, color: "#1d4ed8" }}>{t("Tax posting options")}</div>
                  </div>
                </div>
                <div style={{ display: "grid", gap: 10, padding: 12, overflowY: "auto", minHeight: 0, flex: 1, alignContent: "start" }}>
                  <div style={{ border: "1px solid #e5e7eb", borderRadius: 6, padding: 12, background: "#fff" }}>
                    <div style={{ fontSize: 12, fontWeight: 700, marginBottom: 8, display: "flex", alignItems: "center", gap: 6 }}>
                      Tax Option
                      {renderSettingsInfo("Tax Option", taxOptionDescription, 760)}
                    </div>
                    <div style={{ display: "grid", gap: 8 }}>
                      {["default", "NO_TAX", "TAX-CLASS-TAX1-TAX2", "TAX_CLASS_A_2_SEPARATED", "Tax Class Allocation"].map((opt) => (
                        <label key={opt}><input type="radio" name="tax_option" value={opt} checked={settings.tax_option === opt} onChange={updateSetting("tax_option", "default")} />{" "}{opt}</label>
                      ))}
                    </div>
                  </div>
                </div>
              </div>

              <div style={{ border: "1px solid #bbf7d0", borderRadius: 8, overflow: "hidden", background: "#f7fdf8", display: "flex", flexDirection: "column", minHeight: 0, maxHeight: "min(42vh, 430px)" }}>
                <div style={{ display: "flex", alignItems: "center", gap: 12, padding: "14px 16px", borderBottom: "1px solid #bbf7d0", background: "#f0fdf4", flexShrink: 0 }}>
                  <span style={{ width: 34, height: 34, borderRadius: "50%", background: "#22c55e", color: "#fff", display: "inline-flex", alignItems: "center", justifyContent: "center", fontWeight: 800 }}>4</span>
                  <div>
                    <div style={{ fontSize: 15, fontWeight: 800, color: "#166534" }}>{t("Payments")}</div>
                    <div style={{ fontSize: 10, color: "#15803d" }}>{t("Payment and fee options")}</div>
                  </div>
                </div>
                <div style={{ display: "grid", gap: 10, padding: 12, overflowY: "auto", minHeight: 0, flex: 1, alignContent: "start" }}>
                  <div style={{ border: "1px solid #e5e7eb", borderRadius: 6, padding: 12, background: "#fff" }}>
                    <div style={{ fontSize: 12, fontWeight: 700, marginBottom: 8, display: "flex", alignItems: "center", gap: 6 }}>
                      Retail (R) Credit Card Fees
                      {renderSettingsInfo("Retail (R) Credit Card Fees", "Choose how credit card fees appear in journals: off, as separate debit and credit lines, or deducted from payment with a summary debit.")}
                    </div>
                    <div style={{ display: "grid", gap: 8 }}>
                      <label><input type="radio" name="cc_fees_retail" value="off" checked={settings.cc_fees_retail === "off"} onChange={updateSetting("cc_fees_retail", "off")} />{" "}Off</label>
                      <label><input type="radio" name="cc_fees_retail" value="debit_credit" checked={settings.cc_fees_retail === "debit_credit"} onChange={updateSetting("cc_fees_retail", "off")} />{" "}Show as Debit / Credit</label>
                      <label><input type="radio" name="cc_fees_retail" value="payment_minus_fee" checked={settings.cc_fees_retail === "payment_minus_fee"} onChange={updateSetting("cc_fees_retail", "off")} />{" "}Show as Deducted from Payment | Debit (summary)</label>
                    </div>
                  </div>
                  <div style={{ border: "1px solid #e5e7eb", borderRadius: 6, padding: 12, background: "#fff" }}>
                    <div style={{ fontSize: 12, fontWeight: 700, marginBottom: 8, display: "flex", alignItems: "center", gap: 6 }}>
                      Retail (R) Surcharge
                      {renderSettingsInfo("Retail (R) Surcharge", surchargeDescription, 1200)}
                    </div>
                    <div style={{ display: "flex", flexWrap: "wrap", gap: "8px 14px" }}>
                      <label><input type="radio" name="surcharge_retail" value="off" checked={settings.surcharge_retail === "off"} onChange={updateSetting("surcharge_retail", "off")} />{" "}Off</label>
                      <label><input type="radio" name="surcharge_retail" value="on" checked={settings.surcharge_retail === "on"} onChange={updateSetting("surcharge_retail", "on")} />{" "}On</label>
                    </div>
                  </div>
                  <div style={{ border: "1px solid #e5e7eb", borderRadius: 6, padding: 12, background: "#fff", display: "flex", alignItems: "center", gap: 14, flexWrap: "wrap" }}>
                    <div style={{ fontSize: 12, fontWeight: 700, minWidth: 130 }}>Cash Over/Short</div>
                    <label><input type="radio" name="cash_over_short" value="on" checked={settings.cash_over_short === "on"} onChange={updateSetting("cash_over_short", "off")} />{" "}on</label>
                    <label><input type="radio" name="cash_over_short" value="off" checked={settings.cash_over_short === "off"} onChange={updateSetting("cash_over_short", "off")} />{" "}off</label>
                  </div>
                </div>
              </div>

              <div style={{ gridColumn: "1 / span 1", border: "1px solid #ddd6fe", borderRadius: 8, overflow: "hidden", background: "#fbfaff", display: "flex", flexDirection: "column", minHeight: 0, maxHeight: "min(42vh, 430px)" }}>
                <div style={{ display: "flex", alignItems: "center", gap: 12, padding: "14px 16px", borderBottom: "1px solid #ddd6fe", background: "#f5f3ff", flexShrink: 0 }}>
                  <span style={{ width: 34, height: 34, borderRadius: "50%", background: "#7c3aed", color: "#fff", display: "inline-flex", alignItems: "center", justifyContent: "center", fontWeight: 800 }}>6</span>
                  <div>
                    <div style={{ fontSize: 15, fontWeight: 800, color: "#5b21b6" }}>{t("Regional Settings")}</div>
                    <div style={{ fontSize: 10, color: "#6d28d9" }}>{t("Time zone settings")}</div>
                  </div>
                </div>
                <div style={{ display: "grid", gap: 10, padding: 12, overflowY: "auto", minHeight: 0, flex: 1, alignContent: "start" }}>
                  <div style={{ border: "1px solid #e5e7eb", borderRadius: 6, padding: 12, background: "#fff" }}>
                    <div style={{ fontSize: 12, fontWeight: 700, marginBottom: 8 }}>Time Zone</div>
                    <select value={settings.time_zone} onChange={updateSetting("time_zone", "Eastern Standard Time")} style={{ width: "100%", padding: 8, borderRadius: 6, border: "1px solid #ccc" }}>
                      {TIMEZONES.map((tz) => (<option key={tz.name} value={tz.name}>{tz.name} (UTC{tz.offset})</option>))}
                    </select>
                  </div>
                </div>
              </div>

              <div style={{ border: "1px solid #fde68a", borderRadius: 8, overflow: "hidden", background: "#fffdf5", display: "flex", flexDirection: "column", minHeight: 0, maxHeight: "min(42vh, 430px)" }}>
                <div style={{ display: "flex", alignItems: "center", gap: 12, padding: "14px 16px", borderBottom: "1px solid #fde68a", background: "#fffbeb", flexShrink: 0 }}>
                  <span style={{ width: 34, height: 34, borderRadius: "50%", background: "#f59e0b", color: "#fff", display: "inline-flex", alignItems: "center", justifyContent: "center", fontWeight: 800 }}>7</span>
                  <div>
                    <div style={{ fontSize: 16, fontWeight: 800, color: "#92400e" }}>{t("Automation & Delivery")}</div>
                    <div style={{ fontSize: 11, color: "#b45309" }}>{t("Email delivery settings")}</div>
                  </div>
                </div>
                <div style={{ display: "grid", gap: 10, padding: 12, overflowY: "auto", minHeight: 0, flex: 1, alignContent: "start" }}>
                  <div style={{ border: "1px solid #e5e7eb", borderRadius: 6, padding: 12, background: "#fff" }}>
                    <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 8 }}>Email List</div>
                    <input type="text" placeholder="example1@hotel.com, example2@hotel.com" value={emailList} onChange={(valueOrEvent) => { const value = getValue(valueOrEvent, ""); setEmailList(value); }} style={{ width: "100%", padding: "8px 10px", borderRadius: 6, border: "1px solid #ccc" }} />
                  </div>
                  <div style={{ border: "1px solid #e5e7eb", borderRadius: 6, padding: 12, background: "#fff" }}>
                    <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 8 }}>Time</div>
                    <select value={timeSelection} onChange={(valueOrEvent) => { const value = String(getValue(valueOrEvent, "0")); setTimeSelection(value); }} style={{ width: "100%", padding: "8px 10px", borderRadius: 6, border: "1px solid #ccc" }}>
                      {Array.from({ length: 24 }, (_, i) => (<option key={i} value={i}>{i}:00</option>))}
                    </select>
                  </div>
                </div>
              </div>

              <button
                type="button"
                onClick={openAmortizedSettings}
                disabled={amortizedSettingsLoading}
                aria-label="Open Amortized settings"
                style={{
                  gridColumn: "1 / -1",
                  width: "100%",
                  border: "1px solid #f9a8d4",
                  borderRadius: 8,
                  padding: "12px 16px",
                  background: "#fce7f3",
                  color: "#831843",
                  display: "flex",
                  alignItems: "center",
                  gap: 12,
                  textAlign: "left",
                  cursor: amortizedSettingsLoading ? "wait" : "pointer",
                  opacity: amortizedSettingsLoading ? 0.7 : 1,
                  boxShadow: "0 1px 2px rgba(131, 24, 67, 0.08)",
                }}
              >
                <span style={{ width: 34, height: 34, borderRadius: "50%", background: "#ec4899", color: "#fff", display: "inline-flex", alignItems: "center", justifyContent: "center", fontWeight: 800, flexShrink: 0 }}>8</span>
                <span style={{ flex: 1, minWidth: 0 }}>
                  <span style={{ display: "block", fontSize: 15, fontWeight: 800 }}>Amortized</span>
                  <span style={{ display: "block", marginTop: 2, fontSize: 10, color: "#be185d" }}>Monthly amortized item settings</span>
                </span>
                <span style={{ display: "inline-flex", alignItems: "center", gap: 7, padding: "7px 10px", borderRadius: 6, background: "#be185d", color: "#fff", fontSize: 11, fontWeight: 800, whiteSpace: "nowrap" }}>
                  <FaCog />
                  {amortizedSettingsLoading ? "Loading..." : "Open settings"}
                </span>
              </button>
            </div>

            <div
              style={{
                display: "flex",
                gap: 8,
                justifyContent: "flex-end",
                alignItems: "center",
                flexShrink: 0,
                marginTop: 8,
                paddingTop: 8,
                borderTop: "1px solid #e5e7eb",
                background: "#fff",
              }}
            >
              <div style={{ flex: 1 }}>
                {saveSuccess && (
                  <div style={{ color: "green", fontSize: 18, fontWeight: 600 }} aria-live="polite">
                    ✅ Saved
                  </div>
                )}
                {saveError && (
                  <div style={{ color: "red", fontSize: 14, fontWeight: 500 }} aria-live="assertive">
                    {saveError}
                  </div>
                )}
                {settingsLoading && (
                  <div style={{ color: "#64748b", fontSize: 14 }}>Loading settings...</div>
                )}
                {settingsError && !saveError && (
                  <div style={{ color: "red", fontSize: 14 }}>{settingsError}</div>
                )}
              </div>

              <Button
                size="small"
                fill="true"
                disabled={isSaving}
                onClick={async () => {
                  try {
                    setIsSaving(true);
                    setSaveError(null);
                    setSaveSuccess(false);

                    await saveSettings(settings);
                    dispatch(setUiSettings(normalizeSettings(settings)));

                    setSaveSuccess(true);

                    setTimeout(() => {
                      setSaveSuccess(false);
                      setShowSettings(false);
                    }, 1500);
                  } catch (err) {
                    console.error(err);
                    setSaveError(err.message || "Save failed");
                  } finally {
                    setIsSaving(false);
                  }
                }}
              >
                {isSaving ? "Saving..." : "Save"}
              </Button>

              <Button size="small" variant="secondary" onClick={() => setShowSettings(false)}>
                Cancel
              </Button>
            </div>
          </div>
        </Modal>
      )}

      {showAmortizedSettings && database.currentCompany.type === "RETAIL" && (
        <Modal
          open={showAmortizedSettings}
          isOpen={showAmortizedSettings}
          onClose={closeAmortizedSettings}
          title="Amortized Settings"
          ariaHideApp={false}
        >
          <div
            style={{
              width: "min(94vw, 1500px)",
              maxWidth: 1500,
              maxHeight: "calc(100vh - 96px)",
              padding: 18,
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
              fontSize: 12,
            }}
          >
            <div style={{ overflow: "auto", minHeight: 0, padding: 2 }}>
              {renderAmortizedEditor()}
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                gap: 8,
                flexShrink: 0,
                marginTop: 14,
                paddingTop: 12,
                borderTop: "1px solid #fbcfe8",
              }}
            >
              <div style={{ flex: 1 }}>
                {saveError && (
                  <div style={{ color: "#dc2626", fontSize: 13, fontWeight: 600 }} aria-live="assertive">
                    {saveError}
                  </div>
                )}
              </div>
              <Button
                size="small"
                fill="true"
                disabled={isSaving}
                onClick={async () => {
                  try {
                    setIsSaving(true);
                    setSaveError(null);
                    setSaveSuccess(false);

                    await saveSettings(settings);
                    dispatch(setUiSettings(normalizeSettings(settings)));

                    setAmortizedSnapshot(null);
                    setShowAmortizedSettings(false);
                    setSaveSuccess(true);
                    setTimeout(() => setSaveSuccess(false), 1500);
                  } catch (err) {
                    console.error(err);
                    setSaveError(err.message || "Save failed");
                  } finally {
                    setIsSaving(false);
                  }
                }}
              >
                {isSaving ? "Saving..." : "Save"}
              </Button>
              <Button size="small" variant="secondary" disabled={isSaving} onClick={closeAmortizedSettings}>
                Cancel
              </Button>
            </div>
          </div>
        </Modal>
      )}

      {tabInfo && (
        <div
          onClick={() => setTabInfo(null)}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(15, 23, 42, 0.45)",
            zIndex: 10001,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 24,
          }}
        >
          <div
            onClick={(event) => event.stopPropagation()}
            onKeyDown={(event) => event.stopPropagation()}
            tabIndex={-1}
            style={{
              width: "100%",
              maxWidth: tabInfo.maxWidth || 640,
              maxHeight: "calc(100vh - 48px)",
              background: "#fff",
              borderRadius: 16,
              boxShadow: "0 24px 80px rgba(0,0,0,0.25)",
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div
              style={{
                padding: "16px 20px",
                borderBottom: "1px solid #e2e8f0",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <div style={{ fontSize: 18, fontWeight: 700, color: "#0f172a" }}>
                {tabInfo.title}
              </div>

              <button
                type="button"
                onClick={() => setTabInfo(null)}
                style={{
                  border: "none",
                  background: "transparent",
                  fontSize: 20,
                  cursor: "pointer",
                  color: "#64748b",
                }}
              >
                &times;
              </button>
            </div>

            <div
              style={{
                padding: 20,
                color: "#1e293b",
                lineHeight: 1.6,
                fontSize: 14,
                overflowY: "auto",
                flex: "1 1 auto",
              }}
            >
              <div style={{ marginBottom: 10, fontWeight: 600 }}>Description:</div>
              <div>{tabInfo.description}</div>
            </div>

            <div
              style={{
                padding: "16px 20px",
                borderTop: "1px solid #e2e8f0",
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <Button size="small" fill="true" onClick={() => setTabInfo(null)}>
                Close
              </Button>
            </div>
          </div>
        </div>
      )}


      {enlargedImage && (
        <div
          onClick={() => setEnlargedImage(null)}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(15, 23, 42, 0.82)",
            zIndex: 10002,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 24,
          }}
        >
          <div
            onClick={(event) => event.stopPropagation()}
            style={{ position: "relative", maxWidth: "96vw", maxHeight: "92vh" }}
          >
            <button
              type="button"
              onClick={() => setEnlargedImage(null)}
              style={{
                position: "absolute",
                top: 10,
                right: 10,
                width: 34,
                height: 34,
                borderRadius: "50%",
                border: "1px solid rgba(255,255,255,0.7)",
                background: "rgba(15, 23, 42, 0.72)",
                color: "#fff",
                fontSize: 22,
                lineHeight: "30px",
                cursor: "pointer",
              }}
              aria-label="Close enlarged image"
            >
              &times;
            </button>
            <img
              src={enlargedImage.src}
              alt={enlargedImage.alt}
              style={{
                maxWidth: "96vw",
                maxHeight: "92vh",
                objectFit: "contain",
                borderRadius: 8,
                background: "#fff",
                boxShadow: "0 24px 80px rgba(0,0,0,0.35)",
                display: "block",
              }}
            />
          </div>
        </div>
      )}
      {showSettings && database.currentCompany.type === "RESTOK" && (
        <Modal
          open={showSettings}
          isOpen={showSettings}
          onClose={closeSettingsModal}
          title="Settings"
          ariaHideApp={false}
        >
          <div
            style={{
              width: "min(96vw, 1610px)",
              maxWidth: 1610,
              maxHeight: "86vh",
              minWidth: "min(600px, calc(100vw - 48px))",
              padding: 16,
              display: "flex",
              flexDirection: "column",
              fontSize: 11.5,
              overflow: "hidden",
            }}
          >
            <div
              style={{
                display: "grid",
                gap: 10,
                overflowY: "auto",
                flex: 1,
                minHeight: 0,
                paddingRight: 6,
                paddingBottom: 8,
              }}
            >
              <div className="settings-tab-container" style={{ marginBottom: 4 }} role="tablist" aria-label="Settings sections">
                <button
                  type="button"
                  role="tab"
                  aria-selected={settingsTab === "general"}
                  className={`settings-tab ${settingsTab === "general" ? "settings-tab-active" : ""}`}
                  onClick={() => setSettingsTab("general")}
                >
                  General
                </button>
                <button
                  type="button"
                  role="tab"
                  aria-selected={settingsTab === "meal_period"}
                  className={`settings-tab ${settingsTab === "meal_period" ? "settings-tab-active" : ""}`}
                  onClick={() => setSettingsTab("meal_period")}
                >
                  Meal period
                </button>
              </div>


              {settingsTab === "general" && (
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
                    gap: 14,
                  }}
                >
                  <div style={{ border: "1px solid #fed7aa", borderRadius: 8, overflow: "hidden", background: "#fffaf5" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 12, padding: "14px 16px", borderBottom: "1px solid #fed7aa", background: "#fff7ed" }}>
                      <span style={{ width: 34, height: 34, borderRadius: "50%", background: "#f97316", color: "#fff", display: "inline-flex", alignItems: "center", justifyContent: "center", fontWeight: 800 }}>1</span>
                      <div>
                        <div style={{ fontSize: 15, fontWeight: 800, color: "#9a3412" }}>{t("Data Posting")}</div>
                        <div style={{ fontSize: 10, color: "#c2410c" }}>{t("Posting options")}</div>
                      </div>
                    </div>
                    <div style={{ display: "grid", gap: 10, padding: 12 }}>
                      <div style={{ border: "1px solid #e5e7eb", borderRadius: 6, padding: "12px 86px 12px 12px", background: "#fff", display: "flex", alignItems: "center", gap: 14, flexWrap: "wrap", position: "relative" }}>
                        <div style={{ position: "absolute", top: 8, right: 8 }}>{renderSettingsGroupBadges(["A", "B", "C"])}</div>
                        <div style={{ fontSize: 12, fontWeight: 700, display: "flex", alignItems: "center", gap: 6, minWidth: 110 }}>Show COGS {renderSettingsInfo("Show COGS", cogsDescription, 900)}</div>
                        <label><input type="radio" name="cogs_enabled" value="on" checked={settings.cogs_enabled === "on"} onChange={updateSetting("cogs_enabled", "off")} />{" "}on</label>
                        <label><input type="radio" name="cogs_enabled" value="off" checked={settings.cogs_enabled === "off"} onChange={updateSetting("cogs_enabled", "off")} />{" "}off</label>
                      </div>
                    </div>
                  </div>

                  <div style={{ border: "1px solid #ddd6fe", borderRadius: 8, overflow: "hidden", background: "#fbfaff" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 12, padding: "14px 16px", borderBottom: "1px solid #ddd6fe", background: "#f5f3ff" }}>
                      <span style={{ width: 34, height: 34, borderRadius: "50%", background: "#7c3aed", color: "#fff", display: "inline-flex", alignItems: "center", justifyContent: "center", fontWeight: 800 }}>2</span>
                      <div>
                        <div style={{ fontSize: 15, fontWeight: 800, color: "#5b21b6" }}>{t("Mapping")}</div>
                        <div style={{ fontSize: 10, color: "#6d28d9" }}>{t("Restaurant (K) mapping mode")}</div>
                      </div>
                    </div>
                    <div style={{ display: "grid", gap: 10, padding: 12 }}>
                      <div style={{ border: "1px solid #e5e7eb", borderRadius: 6, padding: 12, background: "#fff" }}>
                        <div style={{ fontSize: 12, fontWeight: 700, marginBottom: 8, display: "flex", alignItems: "center", gap: 6 }}>
                          Restaurant (K) Options
                          {renderSettingsInfo("Restaurant (K) Options", "Choose which Restaurant (K) mode is active: Business Location, Configuration, Order Profile, or Configuration Reporting Tags. Each option uses a separate mapping, and mappings are applied based on the selected configuration.")}
                        </div>
                        <div style={{ display: "grid", gap: 8 }}>
                          <label><input type="radio" name="restok_option" value="business_location" checked={settings.restok_option === "business_location"} onChange={updateSetting("restok_option", "business_location")} />{" "}Business Location</label>
                          <label><input type="radio" name="restok_option" value="revenue_centers" checked={settings.restok_option === "revenue_centers"} onChange={updateSetting("restok_option", "business_location")} />{" "}Configuration</label>
                          <label><input type="radio" name="restok_option" value="order_profile" checked={settings.restok_option === "order_profile"} onChange={updateSetting("restok_option", "business_location")} />{" "}Order Profile</label>
                          <label><input type="radio" name="restok_option" value="order_tags" checked={settings.restok_option === "order_tags"} onChange={updateSetting("restok_option", "business_location")} />{" "}Configuration Reporting Tags</label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div style={{ border: "1px solid #bfdbfe", borderRadius: 8, overflow: "hidden", background: "#f8fbff" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 12, padding: "14px 16px", borderBottom: "1px solid #bfdbfe", background: "#eff6ff" }}>
                      <span style={{ width: 34, height: 34, borderRadius: "50%", background: "#2563eb", color: "#fff", display: "inline-flex", alignItems: "center", justifyContent: "center", fontWeight: 800 }}>3</span>
                      <div>
                        <div style={{ fontSize: 15, fontWeight: 800, color: "#1e3a8a" }}>{t("Visual & Display")}</div>
                        <div style={{ fontSize: 10, color: "#1d4ed8" }}>{t("Report display options")}</div>
                      </div>
                    </div>
                    <div style={{ display: "grid", gap: 10, padding: 12 }}>
                      <div style={{ border: "1px solid #e5e7eb", borderRadius: 6, padding: 12, background: "#fff" }}>
                        <div style={{ fontSize: 12, fontWeight: 700, marginBottom: 8, display: "flex", alignItems: "center", gap: 6 }}>
                          Extra visibility
                          {renderSettingsInfo("Extra visibility", "Enable additional Restaurant (K) reporting fields such as Order Profile, Order Tag, Group Statistic, and Item Statistic. These settings work only when the Business Location option is enabled.")}
                        </div>
                        <div style={{ display: "grid", gap: 8 }}>
                          <label><input type="checkbox" checked={settings.show_order_profile === "on"} onChange={(e) => { const checked = e?.target?.checked ?? false; setSettings((s) => ({ ...s, show_order_profile: checked ? "on" : "off" })); }} />{" "}Show Order Profile</label>
                          <label><input type="checkbox" checked={settings.show_order_tag === "on"} onChange={(e) => { const checked = e?.target?.checked ?? false; setSettings((s) => ({ ...s, show_order_tag: checked ? "on" : "off" })); }} />{" "}Show Order tag</label>
                          <label><input type="checkbox" checked={settings.show_group_statistic === "on"} onChange={(e) => { const checked = e?.target?.checked ?? false; setSettings((s) => ({ ...s, show_group_statistic: checked ? "on" : "off" })); }} />{" "}Group Statistic</label>
                          <label><input type="checkbox" checked={settings.show_item_statistic === "on"} onChange={(e) => { const checked = e?.target?.checked ?? false; setSettings((s) => ({ ...s, show_item_statistic: checked ? "on" : "off" })); }} />{" "}Item Statistic</label>
                        </div>
                      </div>
                      <div style={{ border: "1px solid #e5e7eb", borderRadius: 6, padding: "12px 44px 12px 12px", background: "#fff", display: "flex", alignItems: "center", gap: 14, flexWrap: "nowrap", position: "relative" }}>
                        <div style={{ position: "absolute", top: 8, right: 8 }}>{renderSettingsGroupBadges(["B"])}</div>
                        <div style={{ fontSize: 12, fontWeight: 700, display: "flex", alignItems: "center", gap: 6, minWidth: 230 }}>
                          Payment without description (One line)
                          {renderSettingsInfo("Payment without description", paymentWithoutDescriptionDescription, 900)}
                        </div>
                        <label style={{ whiteSpace: "nowrap" }}><input type="radio" name="NO_DESCRIPTION_PAYMENT_R" value="on" checked={settings.NO_DESCRIPTION_PAYMENT_R === "on"} onChange={updateSetting("NO_DESCRIPTION_PAYMENT_R", "off")} />{" "}on</label>
                        <label style={{ whiteSpace: "nowrap" }}><input type="radio" name="NO_DESCRIPTION_PAYMENT_R" value="off" checked={settings.NO_DESCRIPTION_PAYMENT_R === "off"} onChange={updateSetting("NO_DESCRIPTION_PAYMENT_R", "off")} />{" "}off</label>
                      </div>
                      <div style={{ border: "1px solid #e5e7eb", borderRadius: 6, padding: "12px 44px 12px 12px", background: "#fff", display: "flex", alignItems: "center", gap: 14, flexWrap: "nowrap", position: "relative" }}>
                        <div style={{ position: "absolute", top: 8, right: 8 }}>{renderSettingsGroupBadges(["B"])}</div>
                        <div style={{ fontSize: 12, fontWeight: 700, display: "flex", alignItems: "center", gap: 6, minWidth: 230 }}>
                          Category without description (One line)
                          {renderSettingsInfo("Category without description", categoryWithoutDescriptionDescription, 900)}
                        </div>
                        <label style={{ whiteSpace: "nowrap" }}><input type="radio" name="NO_DESCRIPTION_CATEGORY_R" value="on" checked={settings.NO_DESCRIPTION_CATEGORY_R === "on"} onChange={updateSetting("NO_DESCRIPTION_CATEGORY_R", "off")} />{" "}on</label>
                        <label style={{ whiteSpace: "nowrap" }}><input type="radio" name="NO_DESCRIPTION_CATEGORY_R" value="off" checked={settings.NO_DESCRIPTION_CATEGORY_R === "off"} onChange={updateSetting("NO_DESCRIPTION_CATEGORY_R", "off")} />{" "}off</label>
                      </div>
                    </div>
                  </div>

                  <div style={{ border: "1px solid #bbf7d0", borderRadius: 8, overflow: "hidden", background: "#f7fdf8" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 12, padding: "14px 16px", borderBottom: "1px solid #bbf7d0", background: "#f0fdf4" }}>
                      <span style={{ width: 34, height: 34, borderRadius: "50%", background: "#22c55e", color: "#fff", display: "inline-flex", alignItems: "center", justifyContent: "center", fontWeight: 800 }}>4</span>
                      <div>
                        <div style={{ fontSize: 15, fontWeight: 800, color: "#166534" }}>{t("Payments")}</div>
                        <div style={{ fontSize: 10, color: "#15803d" }}>{t("Payment and fee options")}</div>
                      </div>
                    </div>
                    <div style={{ display: "grid", gap: 10, padding: 12 }}>
                      <div style={{ border: "1px solid #e5e7eb", borderRadius: 6, padding: 12, background: "#fff" }}>
                        <div style={{ fontSize: 12, fontWeight: 700, marginBottom: 8, display: "flex", alignItems: "center", gap: 6 }}>
                          Restaurant (K) Credit Card Fees
                          {renderSettingsInfo("Restaurant (K) Credit Card Fees", "Choose how credit card fees appear in Restaurant (K) journals: off, as separate debit and credit lines, or deducted from payment with a summary debit.")}
                        </div>
                        <div style={{ display: "grid", gap: 8 }}>
                          <label><input type="radio" name="cc_fees_retail" value="off" checked={settings.cc_fees_retail === "off"} onChange={updateSetting("cc_fees_retail", "off")} />{" "}Off</label>
                          <label><input type="radio" name="cc_fees_retail" value="debit_credit" checked={settings.cc_fees_retail === "debit_credit"} onChange={updateSetting("cc_fees_retail", "off")} />{" "}Show as Debit / Credit</label>
                          <label><input type="radio" name="cc_fees_retail" value="payment_minus_fee" checked={settings.cc_fees_retail === "payment_minus_fee"} onChange={updateSetting("cc_fees_retail", "off")} />{" "}Show as Deducted from Payment | Debit (summary)</label>
                        </div>
                      </div>
                      <div style={{ border: "1px solid #e5e7eb", borderRadius: 6, padding: 12, background: "#fff" }}>
                        <div style={{ fontSize: 12, fontWeight: 700, marginBottom: 8, display: "flex", alignItems: "center", gap: 6 }}>
                          Restaurant (K) Surcharge
                          {renderSettingsInfo("Restaurant (K) Surcharge", surchargeDescription, 1200)}
                        </div>
                        <div style={{ display: "grid", gap: 8 }}>
                          <label><input type="radio" name="surcharge_restok" value="off" checked={settings.surcharge_restok === "off"} onChange={updateSetting("surcharge_restok", "off")} />{" "}Off</label>
                          <label><input type="radio" name="surcharge_restok" value="debit_credit" checked={settings.surcharge_restok === "debit_credit"} onChange={updateSetting("surcharge_restok", "off")} />{" "}Show as Debit / Credit</label>
                          <label><input type="radio" name="surcharge_restok" value="payment_minus_fee" checked={settings.surcharge_restok === "payment_minus_fee"} onChange={updateSetting("surcharge_restok", "off")} />{" "}Show as Deducted from Payment | Debit (summary)</label>
                          <label><input type="radio" name="surcharge_restok" value="charge_minus_surcharge" checked={settings.surcharge_restok === "charge_minus_surcharge"} onChange={updateSetting("surcharge_restok", "off")} />{" "}Show as Deducted from Charge | Credit (summary)</label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div style={{ gridColumn: "1 / span 1", border: "1px solid #ddd6fe", borderRadius: 8, overflow: "hidden", background: "#fbfaff" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 12, padding: "14px 16px", borderBottom: "1px solid #ddd6fe", background: "#f5f3ff" }}>
                      <span style={{ width: 34, height: 34, borderRadius: "50%", background: "#7c3aed", color: "#fff", display: "inline-flex", alignItems: "center", justifyContent: "center", fontWeight: 800 }}>5</span>
                      <div>
                        <div style={{ fontSize: 15, fontWeight: 800, color: "#5b21b6" }}>{t("Regional Settings")}</div>
                        <div style={{ fontSize: 10, color: "#6d28d9" }}>{t("Time zone settings")}</div>
                      </div>
                    </div>
                    <div style={{ display: "grid", gap: 10, padding: 12 }}>
                      <div style={{ border: "1px solid #e5e7eb", borderRadius: 6, padding: 12, background: "#fff" }}>
                        <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 8 }}>Time Zone</div>
                        <select value={settings.time_zone} onChange={updateSetting("time_zone", "Eastern Standard Time")} style={{ width: "100%", padding: 8, borderRadius: 6, border: "1px solid #ccc" }}>
                          {TIMEZONES.map((tz) => (<option key={tz.name} value={tz.name}>{tz.name} (UTC{tz.offset})</option>))}
                        </select>
                      </div>
                    </div>
                  </div>

                  <div style={{ border: "1px solid #fde68a", borderRadius: 8, overflow: "hidden", background: "#fffdf5" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 12, padding: "14px 16px", borderBottom: "1px solid #fde68a", background: "#fffbeb" }}>
                      <span style={{ width: 34, height: 34, borderRadius: "50%", background: "#f59e0b", color: "#fff", display: "inline-flex", alignItems: "center", justifyContent: "center", fontWeight: 800 }}>6</span>
                      <div>
                        <div style={{ fontSize: 16, fontWeight: 800, color: "#92400e" }}>{t("Automation & Delivery")}</div>
                        <div style={{ fontSize: 11, color: "#b45309" }}>{t("Email delivery settings")}</div>
                      </div>
                    </div>
                    <div style={{ display: "grid", gap: 10, padding: 12 }}>
                      <div style={{ border: "1px solid #e5e7eb", borderRadius: 6, padding: 12, background: "#fff" }}>
                        <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 8 }}>Email List</div>
                        <input type="text" placeholder="example1@hotel.com, example2@hotel.com" value={emailList} onChange={(valueOrEvent) => { const value = getValue(valueOrEvent, ""); setEmailList(value); }} style={{ width: "100%", padding: "8px 10px", borderRadius: 6, border: "1px solid #ccc" }} />
                      </div>
                      <div style={{ border: "1px solid #e5e7eb", borderRadius: 6, padding: 12, background: "#fff" }}>
                        <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 8 }}>Time</div>
                        <select value={timeSelection} onChange={(valueOrEvent) => { const value = String(getValue(valueOrEvent, "0")); setTimeSelection(value); }} style={{ width: "100%", padding: "8px 10px", borderRadius: 6, border: "1px solid #ccc" }}>
                          {Array.from({ length: 24 }, (_, i) => (<option key={i} value={i}>{i}:00</option>))}
                        </select>
                      </div>
                    </div>
                  </div>
                  {renderSettingsAgenda()}
                </div>
              )}

              {settingsTab === "meal_period" && (
                <div
                  style={{
                    border: "1px solid #ddd",
                    borderRadius: 6,
                    padding: 12,
                    display: "grid",
                    gap: 14,
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 16,
                      flexWrap: "wrap",
                    }}
                  >
                    <div style={{ fontWeight: 600, minWidth: 200 }}>
                      Meal period
                    </div>

                    <label>
                      <input
                        type="radio"
                        name="meal_period_enabled"
                        value="off"
                        checked={settings.meal_period_enabled === "off"}
                        onChange={updateSetting("meal_period_enabled", "off")}
                      />{" "}
                      Off
                    </label>

                    <label>
                      <input
                        type="radio"
                        name="meal_period_enabled"
                        value="on"
                        checked={settings.meal_period_enabled === "on"}
                        onChange={updateSetting("meal_period_enabled", "off")}
                      />{" "}
                      On
                    </label>
                  </div>

                  {settings.meal_period_enabled === "on" && (
                    <div
                      style={{
                        display: "grid",
                        gap: 10,
                      }}
                    >
                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "48px minmax(160px, 1fr) 140px 140px",
                          gap: 10,
                          alignItems: "center",
                          fontWeight: 600,
                        }}
                      >
                        <div>#</div>
                        <div>Name</div>
                        <div>From time</div>
                        <div>To time</div>
                      </div>

                      {[1, 2, 3, 4].map((row) => (
                        <div
                          key={row}
                          style={{
                            display: "grid",
                            gridTemplateColumns: "48px minmax(160px, 1fr) 140px 140px",
                            gap: 10,
                            alignItems: "center",
                          }}
                        >
                          <div style={{ fontWeight: 600 }}>{row}</div>
                          <input
                            type="text"
                            value={settings[`meal_period_${row}_name`] || ""}
                            onChange={(e) => {
                              const value = getValue(e, "");
                              setSettings((s) => ({
                                ...s,
                                [`meal_period_${row}_name`]: value,
                              }));
                            }}
                            style={{
                              padding: "8px 10px",
                              borderRadius: 6,
                              border: "1px solid #ccc",
                              minWidth: 0,
                            }}
                          />
                          <input
                            type="time"
                            value={settings[`meal_period_${row}_from_time`] || ""}
                            onChange={(e) => {
                              const value = getValue(e, "");
                              setSettings((s) => ({
                                ...s,
                                [`meal_period_${row}_from_time`]: value,
                              }));
                            }}
                            style={{
                              padding: "8px 10px",
                              borderRadius: 6,
                              border: "1px solid #ccc",
                            }}
                          />
                          <input
                            type="time"
                            value={settings[`meal_period_${row}_to_time`] || ""}
                            onChange={(e) => {
                              const value = getValue(e, "");
                              setSettings((s) => ({
                                ...s,
                                [`meal_period_${row}_to_time`]: value,
                              }));
                            }}
                            style={{
                              padding: "8px 10px",
                              borderRadius: 6,
                              border: "1px solid #ccc",
                            }}
                          />
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}
            </div>

            <div
              style={{
                display: "flex",
                gap: 8,
                justifyContent: "flex-end",
                alignItems: "center",
                marginTop: 8,
                paddingTop: 8,
                background: "#fff",
                position: "sticky",
                bottom: 0,
                zIndex: 1,
              }}
            >
              <div style={{ flex: 1 }}>
                {saveSuccess && (
                  <div style={{ color: "green", fontSize: 18, fontWeight: 600 }} aria-live="polite">
                    ✅ Saved
                  </div>
                )}
                {saveError && (
                  <div style={{ color: "red", fontSize: 14, fontWeight: 500 }} aria-live="assertive">
                    {saveError}
                  </div>
                )}
                {settingsLoading && (
                  <div style={{ color: "#64748b", fontSize: 14 }}>Loading settings...</div>
                )}
                {settingsError && !saveError && (
                  <div style={{ color: "red", fontSize: 14 }}>{settingsError}</div>
                )}
              </div>

              <Button
                size="small"
                fill="true"
                disabled={isSaving}
                onClick={async () => {
                  try {
                    setIsSaving(true);
                    setSaveError(null);
                    setSaveSuccess(false);

                    await saveSettings(settings);
                    dispatch(setUiSettings(normalizeSettings(settings)));

                    setSaveSuccess(true);

                    setTimeout(() => {
                      setSaveSuccess(false);
                      setShowSettings(false);
                    }, 1500);
                  } catch (err) {
                    console.error(err);
                    setSaveError(err.message || "Save failed");
                  } finally {
                    setIsSaving(false);
                  }
                }}
              >
                {isSaving ? "Saving..." : "Save"}
              </Button>

              <Button size="small" variant="secondary" onClick={() => setShowSettings(false)}>
                Cancel
              </Button>
            </div>
          </div>
        </Modal>
      )}

      {showSettings && database.currentCompany.type === "RESTO" && (
        <Modal
          open={showSettings}
          isOpen={showSettings}
          onClose={closeSettingsModal}
          title="Settings"
          ariaHideApp={false}
        >
          <div
            style={{
              width: "65vw",
              height: "60vh",
              minWidth: 700,
              minHeight: 750,
              padding: 10,
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
            <div style={{ display: "grid", gap: 16 }}>
              <div
                style={{
                  border: "1px solid #ddd",
                  borderRadius: 6,
                  padding: 12,
                  display: "flex",
                  alignItems: "center",
                  gap: 16,
                }}
              >
                <div
                  style={{
                    fontWeight: 600,
                    minWidth: 200,
                    display: "flex",
                    alignItems: "center",
                    gap: 6,
                  }}
                >
                  Payment without description (One line)
                  {renderSettingsInfo("Payment without description", paymentWithoutDescriptionDescription, 900)}
                </div>

                <label style={{ whiteSpace: "nowrap" }}>
                  <input
                    type="radio"
                    name="NO_DESCRIPTION_PAYMENT_L"
                    value="on"
                    checked={settings.NO_DESCRIPTION_PAYMENT_L === "on"}
                    onChange={updateSetting("NO_DESCRIPTION_PAYMENT_L", "off")}
                  />{" "}
                  on
                </label>

                <label style={{ whiteSpace: "nowrap" }}>
                  <input
                    type="radio"
                    name="NO_DESCRIPTION_PAYMENT_L"
                    value="off"
                    checked={settings.NO_DESCRIPTION_PAYMENT_L === "off"}
                    onChange={updateSetting("NO_DESCRIPTION_PAYMENT_L", "off")}
                  />{" "}
                  off
                </label>
              </div>

              <div
                style={{
                  border: "1px solid #ddd",
                  borderRadius: 6,
                  padding: 12,
                  display: "flex",
                  alignItems: "center",
                  gap: 16,
                }}
              >
                <div
                  style={{
                    fontWeight: 600,
                    minWidth: 200,
                    display: "flex",
                    alignItems: "center",
                    gap: 6,
                  }}
                >
                  Category without description (One line)
                  {renderSettingsInfo("Category without description", categoryWithoutDescriptionDescription, 900)}
                </div>

                <label style={{ whiteSpace: "nowrap" }}>
                  <input
                    type="radio"
                    name="NO_DESCRIPTION_CATEGORY_L"
                    value="on"
                    checked={settings.NO_DESCRIPTION_CATEGORY_L === "on"}
                    onChange={updateSetting("NO_DESCRIPTION_CATEGORY_L", "off")}
                  />{" "}
                  on
                </label>

                <label style={{ whiteSpace: "nowrap" }}>
                  <input
                    type="radio"
                    name="NO_DESCRIPTION_CATEGORY_L"
                    value="off"
                    checked={settings.NO_DESCRIPTION_CATEGORY_L === "off"}
                    onChange={updateSetting("NO_DESCRIPTION_CATEGORY_L", "off")}
                  />{" "}
                  off
                </label>
              </div>

              <div
                style={{
                  border: "1px solid #ddd",
                  borderRadius: 6,
                  padding: 12,
                  display: "flex",
                  alignItems: "center",
                  gap: 16,
                }}
              >
                <div style={{ fontWeight: 600, minWidth: 200 }}>
                  Cash Over/Short
                </div>

                <label>
                  <input
                    type="radio"
                    name="cash_over_short"
                    value="on"
                    checked={settings.cash_over_short === "on"}
                    onChange={updateSetting("cash_over_short", "off")}
                  />{" "}
                  on
                </label>

                <label>
                  <input
                    type="radio"
                    name="cash_over_short"
                    value="off"
                    checked={settings.cash_over_short === "off"}
                    onChange={updateSetting("cash_over_short", "off")}
                  />{" "}
                  off
                </label>
              </div>

              <div
                style={{
                  border: "1px solid #ddd",
                  borderRadius: 6,
                  padding: 12,
                  display: "flex",
                  alignItems: "center",
                  gap: 16,
                }}
              >
                <div style={{ fontWeight: 600, minWidth: 200 }}>Time Zone</div>

                <select
                  value={settings.time_zone}
                  onChange={updateSetting("time_zone", "Eastern Standard Time")}
                  style={{
                    minWidth: 420,
                    padding: 6,
                    borderRadius: 6,
                    border: "1px solid #ccc",
                  }}
                >
                  {TIMEZONES.map((tz) => (
                    <option key={tz.name} value={tz.name}>
                      {tz.name} (UTC{tz.offset})
                    </option>
                  ))}
                </select>
              </div>

              <div
                style={{
                  border: "1px solid #ddd",
                  borderRadius: 6,
                  padding: 12,
                  display: "flex",
                  alignItems: "center",
                  gap: 16,
                }}
              >
                <div style={{ fontWeight: 600, minWidth: 200 }}>Email List</div>

                <input
                  type="text"
                  placeholder="example1@hotel.com, example2@hotel.com"
                  value={emailList}
                  onChange={(valueOrEvent) => {
                    const value = getValue(valueOrEvent, "");
                    setEmailList(value);
                  }}
                  style={{
                    flex: 1,
                    padding: "8px 10px",
                    borderRadius: 6,
                    border: "1px solid #ccc",
                    minWidth: 300,
                  }}
                />

                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <div style={{ fontWeight: 600 }}>Time</div>

                  <select
                    value={timeSelection}
                    onChange={(valueOrEvent) => {
                      const value = String(getValue(valueOrEvent, "0"));
                      setTimeSelection(value);
                    }}
                    style={{
                      padding: "8px 10px",
                      borderRadius: 6,
                      border: "1px solid #ccc",
                      minWidth: 80,
                    }}
                  >
                    {Array.from({ length: 24 }, (_, i) => (
                      <option key={i} value={i}>
                        {i}:00
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>

            <div
              style={{
                display: "flex",
                gap: 8,
                justifyContent: "flex-end",
                alignItems: "center",
                marginTop: 8,
              }}
            >
              <div style={{ flex: 1 }}>
                {saveSuccess && (
                  <div style={{ color: "green", fontSize: 18, fontWeight: 600 }} aria-live="polite">
                    ✅ Saved
                  </div>
                )}

                {saveError && (
                  <div style={{ color: "red", fontSize: 14, fontWeight: 500 }} aria-live="assertive">
                    {saveError}
                  </div>
                )}

                {settingsLoading && (
                  <div style={{ color: "#64748b", fontSize: 14 }}>Loading settings...</div>
                )}
                {settingsError && !saveError && (
                  <div style={{ color: "red", fontSize: 14 }}>{settingsError}</div>
                )}
              </div>

              <Button
                size="small"
                fill="true"
                disabled={isSaving}
                onClick={async () => {
                  try {
                    setIsSaving(true);
                    setSaveError(null);
                    setSaveSuccess(false);

                    await saveSettings(settings);
                    dispatch(setUiSettings(normalizeSettings(settings)));

                    setSaveSuccess(true);

                    setTimeout(() => {
                      setSaveSuccess(false);
                      setShowSettings(false);
                    }, 1500);
                  } catch (err) {
                    console.error(err);
                    setSaveError(err.message || "Save failed");
                  } finally {
                    setIsSaving(false);
                  }
                }}
              >
                {isSaving ? "Saving..." : "Save"}
              </Button>

              <Button size="small" variant="secondary" onClick={() => setShowSettings(false)}>
                Cancel
              </Button>
            </div>
          </div>
        </Modal>
      )}
    </Card>
  );
};

export default CategorieBar;


